var Ao = Object.defineProperty;
var Po = (e, t, n) => t in e ? Ao(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var it = (e, t, n) => Po(e, typeof t != "symbol" ? t + "" : t, n);
import "./index.css";
import Be, { forwardRef as jo, useState as Pe, useRef as Bt, useMemo as No, createRef as Mo, useEffect as Me } from "react";
import Do from "react-dom";
var br = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function hn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Lo(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var o = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var Zt = { exports: {} }, lt = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $n;
function ko() {
  if ($n) return lt;
  $n = 1;
  var e = Be, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(i, d, c) {
    var u, f = {}, v = null, O = null;
    c !== void 0 && (v = "" + c), d.key !== void 0 && (v = "" + d.key), d.ref !== void 0 && (O = d.ref);
    for (u in d) r.call(d, u) && !s.hasOwnProperty(u) && (f[u] = d[u]);
    if (i && i.defaultProps) for (u in d = i.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: t, type: i, key: v, ref: O, props: f, _owner: o.current };
  }
  return lt.Fragment = n, lt.jsx = a, lt.jsxs = a, lt;
}
var ct = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fn;
function $o() {
  return Fn || (Fn = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Be, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), i = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), O = Symbol.for("react.offscreen"), m = Symbol.iterator, E = "@@iterator";
    function b(l) {
      if (l === null || typeof l != "object")
        return null;
      var g = m && l[m] || l[E];
      return typeof g == "function" ? g : null;
    }
    var A = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function P(l) {
      {
        for (var g = arguments.length, x = new Array(g > 1 ? g - 1 : 0), F = 1; F < g; F++)
          x[F - 1] = arguments[F];
        R("error", l, x);
      }
    }
    function R(l, g, x) {
      {
        var F = A.ReactDebugCurrentFrame, te = F.getStackAddendum();
        te !== "" && (g += "%s", x = x.concat([te]));
        var se = x.map(function(X) {
          return String(X);
        });
        se.unshift("Warning: " + g), Function.prototype.apply.call(console[l], console, se);
      }
    }
    var N = !1, w = !1, Q = !1, ee = !1, ae = !1, le;
    le = Symbol.for("react.module.reference");
    function k(l) {
      return !!(typeof l == "string" || typeof l == "function" || l === r || l === s || ae || l === o || l === c || l === u || ee || l === O || N || w || Q || typeof l == "object" && l !== null && (l.$$typeof === v || l.$$typeof === f || l.$$typeof === a || l.$$typeof === i || l.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      l.$$typeof === le || l.getModuleId !== void 0));
    }
    function H(l, g, x) {
      var F = l.displayName;
      if (F)
        return F;
      var te = g.displayName || g.name || "";
      return te !== "" ? x + "(" + te + ")" : x;
    }
    function G(l) {
      return l.displayName || "Context";
    }
    function z(l) {
      if (l == null)
        return null;
      if (typeof l.tag == "number" && P("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof l == "function")
        return l.displayName || l.name || null;
      if (typeof l == "string")
        return l;
      switch (l) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case s:
          return "Profiler";
        case o:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof l == "object")
        switch (l.$$typeof) {
          case i:
            var g = l;
            return G(g) + ".Consumer";
          case a:
            var x = l;
            return G(x._context) + ".Provider";
          case d:
            return H(l, l.render, "ForwardRef");
          case f:
            var F = l.displayName || null;
            return F !== null ? F : z(l.type) || "Memo";
          case v: {
            var te = l, se = te._payload, X = te._init;
            try {
              return z(X(se));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var C = Object.assign, S = 0, M, p, j, oe, y, _, $;
    function D() {
    }
    D.__reactDisabledLog = !0;
    function L() {
      {
        if (S === 0) {
          M = console.log, p = console.info, j = console.warn, oe = console.error, y = console.group, _ = console.groupCollapsed, $ = console.groupEnd;
          var l = {
            configurable: !0,
            enumerable: !0,
            value: D,
            writable: !0
          };
          Object.defineProperties(console, {
            info: l,
            log: l,
            warn: l,
            error: l,
            group: l,
            groupCollapsed: l,
            groupEnd: l
          });
        }
        S++;
      }
    }
    function J() {
      {
        if (S--, S === 0) {
          var l = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: C({}, l, {
              value: M
            }),
            info: C({}, l, {
              value: p
            }),
            warn: C({}, l, {
              value: j
            }),
            error: C({}, l, {
              value: oe
            }),
            group: C({}, l, {
              value: y
            }),
            groupCollapsed: C({}, l, {
              value: _
            }),
            groupEnd: C({}, l, {
              value: $
            })
          });
        }
        S < 0 && P("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var U = A.ReactCurrentDispatcher, B;
    function V(l, g, x) {
      {
        if (B === void 0)
          try {
            throw Error();
          } catch (te) {
            var F = te.stack.trim().match(/\n( *(at )?)/);
            B = F && F[1] || "";
          }
        return `
` + B + l;
      }
    }
    var Z = !1, Y;
    {
      var de = typeof WeakMap == "function" ? WeakMap : Map;
      Y = new de();
    }
    function T(l, g) {
      if (!l || Z)
        return "";
      {
        var x = Y.get(l);
        if (x !== void 0)
          return x;
      }
      var F;
      Z = !0;
      var te = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var se;
      se = U.current, U.current = null, L();
      try {
        if (g) {
          var X = function() {
            throw Error();
          };
          if (Object.defineProperty(X.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(X, []);
            } catch (ye) {
              F = ye;
            }
            Reflect.construct(l, [], X);
          } else {
            try {
              X.call();
            } catch (ye) {
              F = ye;
            }
            l.call(X.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ye) {
            F = ye;
          }
          l();
        }
      } catch (ye) {
        if (ye && F && typeof ye.stack == "string") {
          for (var K = ye.stack.split(`
`), he = F.stack.split(`
`), ce = K.length - 1, fe = he.length - 1; ce >= 1 && fe >= 0 && K[ce] !== he[fe]; )
            fe--;
          for (; ce >= 1 && fe >= 0; ce--, fe--)
            if (K[ce] !== he[fe]) {
              if (ce !== 1 || fe !== 1)
                do
                  if (ce--, fe--, fe < 0 || K[ce] !== he[fe]) {
                    var we = `
` + K[ce].replace(" at new ", " at ");
                    return l.displayName && we.includes("<anonymous>") && (we = we.replace("<anonymous>", l.displayName)), typeof l == "function" && Y.set(l, we), we;
                  }
                while (ce >= 1 && fe >= 0);
              break;
            }
        }
      } finally {
        Z = !1, U.current = se, J(), Error.prepareStackTrace = te;
      }
      var Xe = l ? l.displayName || l.name : "", $e = Xe ? V(Xe) : "";
      return typeof l == "function" && Y.set(l, $e), $e;
    }
    function Ee(l, g, x) {
      return T(l, !1);
    }
    function Je(l) {
      var g = l.prototype;
      return !!(g && g.isReactComponent);
    }
    function ke(l, g, x) {
      if (l == null)
        return "";
      if (typeof l == "function")
        return T(l, Je(l));
      if (typeof l == "string")
        return V(l);
      switch (l) {
        case c:
          return V("Suspense");
        case u:
          return V("SuspenseList");
      }
      if (typeof l == "object")
        switch (l.$$typeof) {
          case d:
            return Ee(l.render);
          case f:
            return ke(l.type, g, x);
          case v: {
            var F = l, te = F._payload, se = F._init;
            try {
              return ke(se(te), g, x);
            } catch {
            }
          }
        }
      return "";
    }
    var st = Object.prototype.hasOwnProperty, Rn = {}, Sn = A.ReactDebugCurrentFrame;
    function bt(l) {
      if (l) {
        var g = l._owner, x = ke(l.type, l._source, g ? g.type : null);
        Sn.setExtraStackFrame(x);
      } else
        Sn.setExtraStackFrame(null);
    }
    function ao(l, g, x, F, te) {
      {
        var se = Function.call.bind(st);
        for (var X in l)
          if (se(l, X)) {
            var K = void 0;
            try {
              if (typeof l[X] != "function") {
                var he = Error((F || "React class") + ": " + x + " type `" + X + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof l[X] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw he.name = "Invariant Violation", he;
              }
              K = l[X](g, X, F, x, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ce) {
              K = ce;
            }
            K && !(K instanceof Error) && (bt(te), P("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", F || "React class", x, X, typeof K), bt(null)), K instanceof Error && !(K.message in Rn) && (Rn[K.message] = !0, bt(te), P("Failed %s type: %s", x, K.message), bt(null));
          }
      }
    }
    var io = Array.isArray;
    function Lt(l) {
      return io(l);
    }
    function lo(l) {
      {
        var g = typeof Symbol == "function" && Symbol.toStringTag, x = g && l[Symbol.toStringTag] || l.constructor.name || "Object";
        return x;
      }
    }
    function co(l) {
      try {
        return Tn(l), !1;
      } catch {
        return !0;
      }
    }
    function Tn(l) {
      return "" + l;
    }
    function xn(l) {
      if (co(l))
        return P("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", lo(l)), Tn(l);
    }
    var at = A.ReactCurrentOwner, uo = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Cn, An, kt;
    kt = {};
    function fo(l) {
      if (st.call(l, "ref")) {
        var g = Object.getOwnPropertyDescriptor(l, "ref").get;
        if (g && g.isReactWarning)
          return !1;
      }
      return l.ref !== void 0;
    }
    function po(l) {
      if (st.call(l, "key")) {
        var g = Object.getOwnPropertyDescriptor(l, "key").get;
        if (g && g.isReactWarning)
          return !1;
      }
      return l.key !== void 0;
    }
    function ho(l, g) {
      if (typeof l.ref == "string" && at.current && g && at.current.stateNode !== g) {
        var x = z(at.current.type);
        kt[x] || (P('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', z(at.current.type), l.ref), kt[x] = !0);
      }
    }
    function mo(l, g) {
      {
        var x = function() {
          Cn || (Cn = !0, P("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", g));
        };
        x.isReactWarning = !0, Object.defineProperty(l, "key", {
          get: x,
          configurable: !0
        });
      }
    }
    function yo(l, g) {
      {
        var x = function() {
          An || (An = !0, P("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", g));
        };
        x.isReactWarning = !0, Object.defineProperty(l, "ref", {
          get: x,
          configurable: !0
        });
      }
    }
    var vo = function(l, g, x, F, te, se, X) {
      var K = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: l,
        key: g,
        ref: x,
        props: X,
        // Record the component responsible for creating this element.
        _owner: se
      };
      return K._store = {}, Object.defineProperty(K._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(K, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: F
      }), Object.defineProperty(K, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: te
      }), Object.freeze && (Object.freeze(K.props), Object.freeze(K)), K;
    };
    function bo(l, g, x, F, te) {
      {
        var se, X = {}, K = null, he = null;
        x !== void 0 && (xn(x), K = "" + x), po(g) && (xn(g.key), K = "" + g.key), fo(g) && (he = g.ref, ho(g, te));
        for (se in g)
          st.call(g, se) && !uo.hasOwnProperty(se) && (X[se] = g[se]);
        if (l && l.defaultProps) {
          var ce = l.defaultProps;
          for (se in ce)
            X[se] === void 0 && (X[se] = ce[se]);
        }
        if (K || he) {
          var fe = typeof l == "function" ? l.displayName || l.name || "Unknown" : l;
          K && mo(X, fe), he && yo(X, fe);
        }
        return vo(l, K, he, te, F, at.current, X);
      }
    }
    var $t = A.ReactCurrentOwner, Pn = A.ReactDebugCurrentFrame;
    function Ke(l) {
      if (l) {
        var g = l._owner, x = ke(l.type, l._source, g ? g.type : null);
        Pn.setExtraStackFrame(x);
      } else
        Pn.setExtraStackFrame(null);
    }
    var Ft;
    Ft = !1;
    function It(l) {
      return typeof l == "object" && l !== null && l.$$typeof === t;
    }
    function jn() {
      {
        if ($t.current) {
          var l = z($t.current.type);
          if (l)
            return `

Check the render method of \`` + l + "`.";
        }
        return "";
      }
    }
    function go(l) {
      return "";
    }
    var Nn = {};
    function Eo(l) {
      {
        var g = jn();
        if (!g) {
          var x = typeof l == "string" ? l : l.displayName || l.name;
          x && (g = `

Check the top-level render call using <` + x + ">.");
        }
        return g;
      }
    }
    function Mn(l, g) {
      {
        if (!l._store || l._store.validated || l.key != null)
          return;
        l._store.validated = !0;
        var x = Eo(g);
        if (Nn[x])
          return;
        Nn[x] = !0;
        var F = "";
        l && l._owner && l._owner !== $t.current && (F = " It was passed a child from " + z(l._owner.type) + "."), Ke(l), P('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', x, F), Ke(null);
      }
    }
    function Dn(l, g) {
      {
        if (typeof l != "object")
          return;
        if (Lt(l))
          for (var x = 0; x < l.length; x++) {
            var F = l[x];
            It(F) && Mn(F, g);
          }
        else if (It(l))
          l._store && (l._store.validated = !0);
        else if (l) {
          var te = b(l);
          if (typeof te == "function" && te !== l.entries)
            for (var se = te.call(l), X; !(X = se.next()).done; )
              It(X.value) && Mn(X.value, g);
        }
      }
    }
    function wo(l) {
      {
        var g = l.type;
        if (g == null || typeof g == "string")
          return;
        var x;
        if (typeof g == "function")
          x = g.propTypes;
        else if (typeof g == "object" && (g.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        g.$$typeof === f))
          x = g.propTypes;
        else
          return;
        if (x) {
          var F = z(g);
          ao(x, l.props, "prop", F, l);
        } else if (g.PropTypes !== void 0 && !Ft) {
          Ft = !0;
          var te = z(g);
          P("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", te || "Unknown");
        }
        typeof g.getDefaultProps == "function" && !g.getDefaultProps.isReactClassApproved && P("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function _o(l) {
      {
        for (var g = Object.keys(l.props), x = 0; x < g.length; x++) {
          var F = g[x];
          if (F !== "children" && F !== "key") {
            Ke(l), P("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", F), Ke(null);
            break;
          }
        }
        l.ref !== null && (Ke(l), P("Invalid attribute `ref` supplied to `React.Fragment`."), Ke(null));
      }
    }
    var Ln = {};
    function kn(l, g, x, F, te, se) {
      {
        var X = k(l);
        if (!X) {
          var K = "";
          (l === void 0 || typeof l == "object" && l !== null && Object.keys(l).length === 0) && (K += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var he = go();
          he ? K += he : K += jn();
          var ce;
          l === null ? ce = "null" : Lt(l) ? ce = "array" : l !== void 0 && l.$$typeof === t ? (ce = "<" + (z(l.type) || "Unknown") + " />", K = " Did you accidentally export a JSX literal instead of a component?") : ce = typeof l, P("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ce, K);
        }
        var fe = bo(l, g, x, te, se);
        if (fe == null)
          return fe;
        if (X) {
          var we = g.children;
          if (we !== void 0)
            if (F)
              if (Lt(we)) {
                for (var Xe = 0; Xe < we.length; Xe++)
                  Dn(we[Xe], l);
                Object.freeze && Object.freeze(we);
              } else
                P("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Dn(we, l);
        }
        if (st.call(g, "key")) {
          var $e = z(l), ye = Object.keys(g).filter(function(Co) {
            return Co !== "key";
          }), Ut = ye.length > 0 ? "{key: someKey, " + ye.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ln[$e + Ut]) {
            var xo = ye.length > 0 ? "{" + ye.join(": ..., ") + ": ...}" : "{}";
            P(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ut, $e, xo, $e), Ln[$e + Ut] = !0;
          }
        }
        return l === r ? _o(fe) : wo(fe), fe;
      }
    }
    function Oo(l, g, x) {
      return kn(l, g, x, !0);
    }
    function Ro(l, g, x) {
      return kn(l, g, x, !1);
    }
    var So = Ro, To = Oo;
    ct.Fragment = r, ct.jsx = So, ct.jsxs = To;
  }()), ct;
}
process.env.NODE_ENV === "production" ? Zt.exports = ko() : Zt.exports = $o();
var W = Zt.exports, Ie = /* @__PURE__ */ ((e) => (e.amplifyEnrollment = "amplify-enrollment", e.singleSession = "single-session", e))(Ie || {}), gr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var s = "", a = 0; a < arguments.length; a++) {
        var i = arguments[a];
        i && (s = o(s, r(i)));
      }
      return s;
    }
    function r(s) {
      if (typeof s == "string" || typeof s == "number")
        return s;
      if (typeof s != "object")
        return "";
      if (Array.isArray(s))
        return n.apply(null, s);
      if (s.toString !== Object.prototype.toString && !s.toString.toString().includes("[native code]"))
        return s.toString();
      var a = "";
      for (var i in s)
        t.call(s, i) && s[i] && (a = o(a, i));
      return a;
    }
    function o(s, a) {
      return a ? s ? s + " " + a : s + a : s;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(gr);
var Fo = gr.exports;
const ie = /* @__PURE__ */ hn(Fo);
var Qt = { exports: {} }, Ve = {}, en = { exports: {} }, gt = { exports: {} }, ne = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var In;
function Io() {
  if (In) return ne;
  In = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, i = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, v = e ? Symbol.for("react.suspense_list") : 60120, O = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, E = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, A = e ? Symbol.for("react.responder") : 60118, P = e ? Symbol.for("react.scope") : 60119;
  function R(w) {
    if (typeof w == "object" && w !== null) {
      var Q = w.$$typeof;
      switch (Q) {
        case t:
          switch (w = w.type, w) {
            case d:
            case c:
            case r:
            case s:
            case o:
            case f:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case i:
                case u:
                case m:
                case O:
                case a:
                  return w;
                default:
                  return Q;
              }
          }
        case n:
          return Q;
      }
    }
  }
  function N(w) {
    return R(w) === c;
  }
  return ne.AsyncMode = d, ne.ConcurrentMode = c, ne.ContextConsumer = i, ne.ContextProvider = a, ne.Element = t, ne.ForwardRef = u, ne.Fragment = r, ne.Lazy = m, ne.Memo = O, ne.Portal = n, ne.Profiler = s, ne.StrictMode = o, ne.Suspense = f, ne.isAsyncMode = function(w) {
    return N(w) || R(w) === d;
  }, ne.isConcurrentMode = N, ne.isContextConsumer = function(w) {
    return R(w) === i;
  }, ne.isContextProvider = function(w) {
    return R(w) === a;
  }, ne.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === t;
  }, ne.isForwardRef = function(w) {
    return R(w) === u;
  }, ne.isFragment = function(w) {
    return R(w) === r;
  }, ne.isLazy = function(w) {
    return R(w) === m;
  }, ne.isMemo = function(w) {
    return R(w) === O;
  }, ne.isPortal = function(w) {
    return R(w) === n;
  }, ne.isProfiler = function(w) {
    return R(w) === s;
  }, ne.isStrictMode = function(w) {
    return R(w) === o;
  }, ne.isSuspense = function(w) {
    return R(w) === f;
  }, ne.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === r || w === c || w === s || w === o || w === f || w === v || typeof w == "object" && w !== null && (w.$$typeof === m || w.$$typeof === O || w.$$typeof === a || w.$$typeof === i || w.$$typeof === u || w.$$typeof === b || w.$$typeof === A || w.$$typeof === P || w.$$typeof === E);
  }, ne.typeOf = R, ne;
}
var re = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Un;
function Uo() {
  return Un || (Un = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, i = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, v = e ? Symbol.for("react.suspense_list") : 60120, O = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, E = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, A = e ? Symbol.for("react.responder") : 60118, P = e ? Symbol.for("react.scope") : 60119;
    function R(T) {
      return typeof T == "string" || typeof T == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      T === r || T === c || T === s || T === o || T === f || T === v || typeof T == "object" && T !== null && (T.$$typeof === m || T.$$typeof === O || T.$$typeof === a || T.$$typeof === i || T.$$typeof === u || T.$$typeof === b || T.$$typeof === A || T.$$typeof === P || T.$$typeof === E);
    }
    function N(T) {
      if (typeof T == "object" && T !== null) {
        var Ee = T.$$typeof;
        switch (Ee) {
          case t:
            var Je = T.type;
            switch (Je) {
              case d:
              case c:
              case r:
              case s:
              case o:
              case f:
                return Je;
              default:
                var ke = Je && Je.$$typeof;
                switch (ke) {
                  case i:
                  case u:
                  case m:
                  case O:
                  case a:
                    return ke;
                  default:
                    return Ee;
                }
            }
          case n:
            return Ee;
        }
      }
    }
    var w = d, Q = c, ee = i, ae = a, le = t, k = u, H = r, G = m, z = O, C = n, S = s, M = o, p = f, j = !1;
    function oe(T) {
      return j || (j = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), y(T) || N(T) === d;
    }
    function y(T) {
      return N(T) === c;
    }
    function _(T) {
      return N(T) === i;
    }
    function $(T) {
      return N(T) === a;
    }
    function D(T) {
      return typeof T == "object" && T !== null && T.$$typeof === t;
    }
    function L(T) {
      return N(T) === u;
    }
    function J(T) {
      return N(T) === r;
    }
    function U(T) {
      return N(T) === m;
    }
    function B(T) {
      return N(T) === O;
    }
    function V(T) {
      return N(T) === n;
    }
    function Z(T) {
      return N(T) === s;
    }
    function Y(T) {
      return N(T) === o;
    }
    function de(T) {
      return N(T) === f;
    }
    re.AsyncMode = w, re.ConcurrentMode = Q, re.ContextConsumer = ee, re.ContextProvider = ae, re.Element = le, re.ForwardRef = k, re.Fragment = H, re.Lazy = G, re.Memo = z, re.Portal = C, re.Profiler = S, re.StrictMode = M, re.Suspense = p, re.isAsyncMode = oe, re.isConcurrentMode = y, re.isContextConsumer = _, re.isContextProvider = $, re.isElement = D, re.isForwardRef = L, re.isFragment = J, re.isLazy = U, re.isMemo = B, re.isPortal = V, re.isProfiler = Z, re.isStrictMode = Y, re.isSuspense = de, re.isValidElementType = R, re.typeOf = N;
  }()), re;
}
var Bn;
function Er() {
  return Bn || (Bn = 1, process.env.NODE_ENV === "production" ? gt.exports = Io() : gt.exports = Uo()), gt.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var qt, qn;
function Bo() {
  if (qn) return qt;
  qn = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var a = {}, i = 0; i < 10; i++)
        a["_" + String.fromCharCode(i)] = i;
      var d = Object.getOwnPropertyNames(a).map(function(u) {
        return a[u];
      });
      if (d.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return qt = o() ? Object.assign : function(s, a) {
    for (var i, d = r(s), c, u = 1; u < arguments.length; u++) {
      i = Object(arguments[u]);
      for (var f in i)
        t.call(i, f) && (d[f] = i[f]);
      if (e) {
        c = e(i);
        for (var v = 0; v < c.length; v++)
          n.call(i, c[v]) && (d[c[v]] = i[c[v]]);
      }
    }
    return d;
  }, qt;
}
var Wt, Wn;
function mn() {
  if (Wn) return Wt;
  Wn = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Wt = e, Wt;
}
var Ht, Hn;
function wr() {
  return Hn || (Hn = 1, Ht = Function.call.bind(Object.prototype.hasOwnProperty)), Ht;
}
var Gt, Gn;
function qo() {
  if (Gn) return Gt;
  Gn = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = mn(), n = {}, r = wr();
    e = function(s) {
      var a = "Warning: " + s;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function o(s, a, i, d, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in s)
        if (r(s, u)) {
          var f;
          try {
            if (typeof s[u] != "function") {
              var v = Error(
                (d || "React class") + ": " + i + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw v.name = "Invariant Violation", v;
            }
            f = s[u](a, u, d, i, null, t);
          } catch (m) {
            f = m;
          }
          if (f && !(f instanceof Error) && e(
            (d || "React class") + ": type specification of " + i + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var O = c ? c() : "";
            e(
              "Failed " + i + " type: " + f.message + (O ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Gt = o, Gt;
}
var Vt, Vn;
function Wo() {
  if (Vn) return Vt;
  Vn = 1;
  var e = Er(), t = Bo(), n = mn(), r = wr(), o = qo(), s = function() {
  };
  process.env.NODE_ENV !== "production" && (s = function(i) {
    var d = "Warning: " + i;
    typeof console < "u" && console.error(d);
    try {
      throw new Error(d);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return Vt = function(i, d) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function f(y) {
      var _ = y && (c && y[c] || y[u]);
      if (typeof _ == "function")
        return _;
    }
    var v = "<<anonymous>>", O = {
      array: A("array"),
      bigint: A("bigint"),
      bool: A("boolean"),
      func: A("function"),
      number: A("number"),
      object: A("object"),
      string: A("string"),
      symbol: A("symbol"),
      any: P(),
      arrayOf: R,
      element: N(),
      elementType: w(),
      instanceOf: Q,
      node: k(),
      objectOf: ae,
      oneOf: ee,
      oneOfType: le,
      shape: G,
      exact: z
    };
    function m(y, _) {
      return y === _ ? y !== 0 || 1 / y === 1 / _ : y !== y && _ !== _;
    }
    function E(y, _) {
      this.message = y, this.data = _ && typeof _ == "object" ? _ : {}, this.stack = "";
    }
    E.prototype = Error.prototype;
    function b(y) {
      if (process.env.NODE_ENV !== "production")
        var _ = {}, $ = 0;
      function D(J, U, B, V, Z, Y, de) {
        if (V = V || v, Y = Y || B, de !== n) {
          if (d) {
            var T = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw T.name = "Invariant Violation", T;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Ee = V + ":" + B;
            !_[Ee] && // Avoid spamming the console because they are often not actionable except for lib authors
            $ < 3 && (s(
              "You are manually calling a React.PropTypes validation function for the `" + Y + "` prop on `" + V + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), _[Ee] = !0, $++);
          }
        }
        return U[B] == null ? J ? U[B] === null ? new E("The " + Z + " `" + Y + "` is marked as required " + ("in `" + V + "`, but its value is `null`.")) : new E("The " + Z + " `" + Y + "` is marked as required in " + ("`" + V + "`, but its value is `undefined`.")) : null : y(U, B, V, Z, Y);
      }
      var L = D.bind(null, !1);
      return L.isRequired = D.bind(null, !0), L;
    }
    function A(y) {
      function _($, D, L, J, U, B) {
        var V = $[D], Z = M(V);
        if (Z !== y) {
          var Y = p(V);
          return new E(
            "Invalid " + J + " `" + U + "` of type " + ("`" + Y + "` supplied to `" + L + "`, expected ") + ("`" + y + "`."),
            { expectedType: y }
          );
        }
        return null;
      }
      return b(_);
    }
    function P() {
      return b(a);
    }
    function R(y) {
      function _($, D, L, J, U) {
        if (typeof y != "function")
          return new E("Property `" + U + "` of component `" + L + "` has invalid PropType notation inside arrayOf.");
        var B = $[D];
        if (!Array.isArray(B)) {
          var V = M(B);
          return new E("Invalid " + J + " `" + U + "` of type " + ("`" + V + "` supplied to `" + L + "`, expected an array."));
        }
        for (var Z = 0; Z < B.length; Z++) {
          var Y = y(B, Z, L, J, U + "[" + Z + "]", n);
          if (Y instanceof Error)
            return Y;
        }
        return null;
      }
      return b(_);
    }
    function N() {
      function y(_, $, D, L, J) {
        var U = _[$];
        if (!i(U)) {
          var B = M(U);
          return new E("Invalid " + L + " `" + J + "` of type " + ("`" + B + "` supplied to `" + D + "`, expected a single ReactElement."));
        }
        return null;
      }
      return b(y);
    }
    function w() {
      function y(_, $, D, L, J) {
        var U = _[$];
        if (!e.isValidElementType(U)) {
          var B = M(U);
          return new E("Invalid " + L + " `" + J + "` of type " + ("`" + B + "` supplied to `" + D + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return b(y);
    }
    function Q(y) {
      function _($, D, L, J, U) {
        if (!($[D] instanceof y)) {
          var B = y.name || v, V = oe($[D]);
          return new E("Invalid " + J + " `" + U + "` of type " + ("`" + V + "` supplied to `" + L + "`, expected ") + ("instance of `" + B + "`."));
        }
        return null;
      }
      return b(_);
    }
    function ee(y) {
      if (!Array.isArray(y))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : s("Invalid argument supplied to oneOf, expected an array.")), a;
      function _($, D, L, J, U) {
        for (var B = $[D], V = 0; V < y.length; V++)
          if (m(B, y[V]))
            return null;
        var Z = JSON.stringify(y, function(de, T) {
          var Ee = p(T);
          return Ee === "symbol" ? String(T) : T;
        });
        return new E("Invalid " + J + " `" + U + "` of value `" + String(B) + "` " + ("supplied to `" + L + "`, expected one of " + Z + "."));
      }
      return b(_);
    }
    function ae(y) {
      function _($, D, L, J, U) {
        if (typeof y != "function")
          return new E("Property `" + U + "` of component `" + L + "` has invalid PropType notation inside objectOf.");
        var B = $[D], V = M(B);
        if (V !== "object")
          return new E("Invalid " + J + " `" + U + "` of type " + ("`" + V + "` supplied to `" + L + "`, expected an object."));
        for (var Z in B)
          if (r(B, Z)) {
            var Y = y(B, Z, L, J, U + "." + Z, n);
            if (Y instanceof Error)
              return Y;
          }
        return null;
      }
      return b(_);
    }
    function le(y) {
      if (!Array.isArray(y))
        return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var _ = 0; _ < y.length; _++) {
        var $ = y[_];
        if (typeof $ != "function")
          return s(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + j($) + " at index " + _ + "."
          ), a;
      }
      function D(L, J, U, B, V) {
        for (var Z = [], Y = 0; Y < y.length; Y++) {
          var de = y[Y], T = de(L, J, U, B, V, n);
          if (T == null)
            return null;
          T.data && r(T.data, "expectedType") && Z.push(T.data.expectedType);
        }
        var Ee = Z.length > 0 ? ", expected one of type [" + Z.join(", ") + "]" : "";
        return new E("Invalid " + B + " `" + V + "` supplied to " + ("`" + U + "`" + Ee + "."));
      }
      return b(D);
    }
    function k() {
      function y(_, $, D, L, J) {
        return C(_[$]) ? null : new E("Invalid " + L + " `" + J + "` supplied to " + ("`" + D + "`, expected a ReactNode."));
      }
      return b(y);
    }
    function H(y, _, $, D, L) {
      return new E(
        (y || "React class") + ": " + _ + " type `" + $ + "." + D + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + L + "`."
      );
    }
    function G(y) {
      function _($, D, L, J, U) {
        var B = $[D], V = M(B);
        if (V !== "object")
          return new E("Invalid " + J + " `" + U + "` of type `" + V + "` " + ("supplied to `" + L + "`, expected `object`."));
        for (var Z in y) {
          var Y = y[Z];
          if (typeof Y != "function")
            return H(L, J, U, Z, p(Y));
          var de = Y(B, Z, L, J, U + "." + Z, n);
          if (de)
            return de;
        }
        return null;
      }
      return b(_);
    }
    function z(y) {
      function _($, D, L, J, U) {
        var B = $[D], V = M(B);
        if (V !== "object")
          return new E("Invalid " + J + " `" + U + "` of type `" + V + "` " + ("supplied to `" + L + "`, expected `object`."));
        var Z = t({}, $[D], y);
        for (var Y in Z) {
          var de = y[Y];
          if (r(y, Y) && typeof de != "function")
            return H(L, J, U, Y, p(de));
          if (!de)
            return new E(
              "Invalid " + J + " `" + U + "` key `" + Y + "` supplied to `" + L + "`.\nBad object: " + JSON.stringify($[D], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(y), null, "  ")
            );
          var T = de(B, Y, L, J, U + "." + Y, n);
          if (T)
            return T;
        }
        return null;
      }
      return b(_);
    }
    function C(y) {
      switch (typeof y) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !y;
        case "object":
          if (Array.isArray(y))
            return y.every(C);
          if (y === null || i(y))
            return !0;
          var _ = f(y);
          if (_) {
            var $ = _.call(y), D;
            if (_ !== y.entries) {
              for (; !(D = $.next()).done; )
                if (!C(D.value))
                  return !1;
            } else
              for (; !(D = $.next()).done; ) {
                var L = D.value;
                if (L && !C(L[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function S(y, _) {
      return y === "symbol" ? !0 : _ ? _["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && _ instanceof Symbol : !1;
    }
    function M(y) {
      var _ = typeof y;
      return Array.isArray(y) ? "array" : y instanceof RegExp ? "object" : S(_, y) ? "symbol" : _;
    }
    function p(y) {
      if (typeof y > "u" || y === null)
        return "" + y;
      var _ = M(y);
      if (_ === "object") {
        if (y instanceof Date)
          return "date";
        if (y instanceof RegExp)
          return "regexp";
      }
      return _;
    }
    function j(y) {
      var _ = p(y);
      switch (_) {
        case "array":
        case "object":
          return "an " + _;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + _;
        default:
          return _;
      }
    }
    function oe(y) {
      return !y.constructor || !y.constructor.name ? v : y.constructor.name;
    }
    return O.checkPropTypes = o, O.resetWarningCache = o.resetWarningCache, O.PropTypes = O, O;
  }, Vt;
}
var Yt, Yn;
function Ho() {
  if (Yn) return Yt;
  Yn = 1;
  var e = mn();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Yt = function() {
    function r(a, i, d, c, u, f) {
      if (f !== e) {
        var v = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw v.name = "Invariant Violation", v;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var s = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return s.PropTypes = s, s;
  }, Yt;
}
if (process.env.NODE_ENV !== "production") {
  var Go = Er(), Vo = !0;
  en.exports = Wo()(Go.isElement, Vo);
} else
  en.exports = Ho()();
var yn = en.exports;
const _e = /* @__PURE__ */ hn(yn);
var tn = { exports: {} }, xe = {}, nn = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = u;
  /*!
   * Adapted from jQuery UI core
   *
   * http://jqueryui.com
   *
   * Copyright 2014 jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *
   * http://api.jqueryui.com/category/ui-core/
   */
  var n = "none", r = "contents", o = /input|select|textarea|button|object|iframe/;
  function s(f, v) {
    return v.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
    f.scrollWidth <= 0 && f.scrollHeight <= 0;
  }
  function a(f) {
    var v = f.offsetWidth <= 0 && f.offsetHeight <= 0;
    if (v && !f.innerHTML) return !0;
    try {
      var O = window.getComputedStyle(f), m = O.getPropertyValue("display");
      return v ? m !== r && s(f, O) : m === n;
    } catch {
      return console.warn("Failed to inspect element style"), !1;
    }
  }
  function i(f) {
    for (var v = f, O = f.getRootNode && f.getRootNode(); v && v !== document.body; ) {
      if (O && v === O && (v = O.host.parentNode), a(v)) return !1;
      v = v.parentNode;
    }
    return !0;
  }
  function d(f, v) {
    var O = f.nodeName.toLowerCase(), m = o.test(O) && !f.disabled || O === "a" && f.href || v;
    return m && i(f);
  }
  function c(f) {
    var v = f.getAttribute("tabindex");
    v === null && (v = void 0);
    var O = isNaN(v);
    return (O || v >= 0) && d(f, !O);
  }
  function u(f) {
    var v = [].slice.call(f.querySelectorAll("*"), 0).reduce(function(O, m) {
      return O.concat(m.shadowRoot ? u(m.shadowRoot) : [m]);
    }, []);
    return v.filter(c);
  }
  e.exports = t.default;
})(nn, nn.exports);
var _r = nn.exports;
Object.defineProperty(xe, "__esModule", {
  value: !0
});
xe.resetState = Ko;
xe.log = Xo;
xe.handleBlur = dt;
xe.handleFocus = pt;
xe.markForFocusLater = Zo;
xe.returnFocus = Qo;
xe.popWithoutFocus = es;
xe.setupScopedFocus = ts;
xe.teardownScopedFocus = ns;
var Yo = _r, zo = Jo(Yo);
function Jo(e) {
  return e && e.__esModule ? e : { default: e };
}
var Ye = [], Ze = null, rn = !1;
function Ko() {
  Ye = [];
}
function Xo() {
  process.env.NODE_ENV !== "production" && (console.log("focusManager ----------"), Ye.forEach(function(e) {
    var t = e || {};
    console.log(t.nodeName, t.className, t.id);
  }), console.log("end focusManager ----------"));
}
function dt() {
  rn = !0;
}
function pt() {
  if (rn) {
    if (rn = !1, !Ze)
      return;
    setTimeout(function() {
      if (!Ze.contains(document.activeElement)) {
        var e = (0, zo.default)(Ze)[0] || Ze;
        e.focus();
      }
    }, 0);
  }
}
function Zo() {
  Ye.push(document.activeElement);
}
function Qo() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, t = null;
  try {
    Ye.length !== 0 && (t = Ye.pop(), t.focus({ preventScroll: e }));
    return;
  } catch {
    console.warn(["You tried to return focus to", t, "but it is not in the DOM anymore"].join(" "));
  }
}
function es() {
  Ye.length > 0 && Ye.pop();
}
function ts(e) {
  Ze = e, window.addEventListener ? (window.addEventListener("blur", dt, !1), document.addEventListener("focus", pt, !0)) : (window.attachEvent("onBlur", dt), document.attachEvent("onFocus", pt));
}
function ns() {
  Ze = null, window.addEventListener ? (window.removeEventListener("blur", dt), document.removeEventListener("focus", pt)) : (window.detachEvent("onBlur", dt), document.detachEvent("onFocus", pt));
}
var on = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  var n = _r, r = o(n);
  function o(i) {
    return i && i.__esModule ? i : { default: i };
  }
  function s() {
    var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
    return i.activeElement.shadowRoot ? s(i.activeElement.shadowRoot) : i.activeElement;
  }
  function a(i, d) {
    var c = (0, r.default)(i);
    if (!c.length) {
      d.preventDefault();
      return;
    }
    var u = void 0, f = d.shiftKey, v = c[0], O = c[c.length - 1], m = s();
    if (i === m) {
      if (!f) return;
      u = O;
    }
    if (O === m && !f && (u = v), v === m && f && (u = O), u) {
      d.preventDefault(), u.focus();
      return;
    }
    var E = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent), b = E != null && E[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    if (b) {
      var A = c.indexOf(m);
      if (A > -1 && (A += f ? -1 : 1), u = c[A], typeof u > "u") {
        d.preventDefault(), u = f ? O : v, u.focus();
        return;
      }
      d.preventDefault(), u.focus();
    }
  }
  e.exports = t.default;
})(on, on.exports);
var rs = on.exports, Ce = {}, os = process.env.NODE_ENV !== "production", Or = function() {
};
if (os) {
  var ss = function(t, n) {
    var r = arguments.length;
    n = new Array(r > 1 ? r - 1 : 0);
    for (var o = 1; o < r; o++)
      n[o - 1] = arguments[o];
    var s = 0, a = "Warning: " + t.replace(/%s/g, function() {
      return n[s++];
    });
    typeof console < "u" && console.error(a);
    try {
      throw new Error(a);
    } catch {
    }
  };
  Or = function(e, t, n) {
    var r = arguments.length;
    n = new Array(r > 2 ? r - 2 : 0);
    for (var o = 2; o < r; o++)
      n[o - 2] = arguments[o];
    if (t === void 0)
      throw new Error(
        "`warning(condition, format, ...args)` requires a warning message argument"
      );
    e || ss.apply(null, [t].concat(n));
  };
}
var as = Or, Se = {}, Rr = { exports: {} };
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
(function(e) {
  (function() {
    var t = !!(typeof window < "u" && window.document && window.document.createElement), n = {
      canUseDOM: t,
      canUseWorkers: typeof Worker < "u",
      canUseEventListeners: t && !!(window.addEventListener || window.attachEvent),
      canUseViewport: t && !!window.screen
    };
    e.exports ? e.exports = n : window.ExecutionEnvironment = n;
  })();
})(Rr);
var is = Rr.exports;
Object.defineProperty(Se, "__esModule", {
  value: !0
});
Se.canUseDOM = Se.SafeNodeList = Se.SafeHTMLCollection = void 0;
var ls = is, cs = us(ls);
function us(e) {
  return e && e.__esModule ? e : { default: e };
}
var At = cs.default, fs = At.canUseDOM ? window.HTMLElement : {};
Se.SafeHTMLCollection = At.canUseDOM ? window.HTMLCollection : {};
Se.SafeNodeList = At.canUseDOM ? window.NodeList : {};
Se.canUseDOM = At.canUseDOM;
Se.default = fs;
Object.defineProperty(Ce, "__esModule", {
  value: !0
});
Ce.resetState = ys;
Ce.log = vs;
Ce.assertNodeList = Sr;
Ce.setElement = bs;
Ce.validateElement = vn;
Ce.hide = gs;
Ce.show = Es;
Ce.documentNotReadyOrSSRTesting = ws;
var ds = as, ps = ms(ds), hs = Se;
function ms(e) {
  return e && e.__esModule ? e : { default: e };
}
var be = null;
function ys() {
  be && (be.removeAttribute ? be.removeAttribute("aria-hidden") : be.length != null ? be.forEach(function(e) {
    return e.removeAttribute("aria-hidden");
  }) : document.querySelectorAll(be).forEach(function(e) {
    return e.removeAttribute("aria-hidden");
  })), be = null;
}
function vs() {
  if (process.env.NODE_ENV !== "production") {
    var e = be || {};
    console.log("ariaAppHider ----------"), console.log(e.nodeName, e.className, e.id), console.log("end ariaAppHider ----------");
  }
}
function Sr(e, t) {
  if (!e || !e.length)
    throw new Error("react-modal: No elements were found for selector " + t + ".");
}
function bs(e) {
  var t = e;
  if (typeof t == "string" && hs.canUseDOM) {
    var n = document.querySelectorAll(t);
    Sr(n, t), t = n;
  }
  return be = t || be, be;
}
function vn(e) {
  var t = e || be;
  return t ? Array.isArray(t) || t instanceof HTMLCollection || t instanceof NodeList ? t : [t] : ((0, ps.default)(!1, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" ")), []);
}
function gs(e) {
  var t = !0, n = !1, r = void 0;
  try {
    for (var o = vn(e)[Symbol.iterator](), s; !(t = (s = o.next()).done); t = !0) {
      var a = s.value;
      a.setAttribute("aria-hidden", "true");
    }
  } catch (i) {
    n = !0, r = i;
  } finally {
    try {
      !t && o.return && o.return();
    } finally {
      if (n)
        throw r;
    }
  }
}
function Es(e) {
  var t = !0, n = !1, r = void 0;
  try {
    for (var o = vn(e)[Symbol.iterator](), s; !(t = (s = o.next()).done); t = !0) {
      var a = s.value;
      a.removeAttribute("aria-hidden");
    }
  } catch (i) {
    n = !0, r = i;
  } finally {
    try {
      !t && o.return && o.return();
    } finally {
      if (n)
        throw r;
    }
  }
}
function ws() {
  be = null;
}
var et = {};
Object.defineProperty(et, "__esModule", {
  value: !0
});
et.resetState = _s;
et.log = Os;
var qe = {}, We = {};
function zn(e, t) {
  e.classList.remove(t);
}
function _s() {
  var e = document.getElementsByTagName("html")[0];
  for (var t in qe)
    zn(e, qe[t]);
  var n = document.body;
  for (var r in We)
    zn(n, We[r]);
  qe = {}, We = {};
}
function Os() {
  if (process.env.NODE_ENV !== "production") {
    var e = document.getElementsByTagName("html")[0].className, t = `Show tracked classes:

`;
    t += "<html /> (" + e + `):
  `;
    for (var n in qe)
      t += "  " + n + " " + qe[n] + `
  `;
    e = document.body.className, t += `

doc.body (` + e + `):
  `;
    for (var r in We)
      t += "  " + r + " " + We[r] + `
  `;
    t += `
`, console.log(t);
  }
}
var Rs = function(t, n) {
  return t[n] || (t[n] = 0), t[n] += 1, n;
}, Ss = function(t, n) {
  return t[n] && (t[n] -= 1), n;
}, Ts = function(t, n, r) {
  r.forEach(function(o) {
    Rs(n, o), t.add(o);
  });
}, xs = function(t, n, r) {
  r.forEach(function(o) {
    Ss(n, o), n[o] === 0 && t.remove(o);
  });
};
et.add = function(t, n) {
  return Ts(t.classList, t.nodeName.toLowerCase() == "html" ? qe : We, n.split(" "));
};
et.remove = function(t, n) {
  return xs(t.classList, t.nodeName.toLowerCase() == "html" ? qe : We, n.split(" "));
};
var tt = {};
Object.defineProperty(tt, "__esModule", {
  value: !0
});
tt.log = As;
tt.resetState = Ps;
function Cs(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
var Tr = function e() {
  var t = this;
  Cs(this, e), this.register = function(n) {
    if (t.openInstances.indexOf(n) !== -1) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Cannot register modal instance that's already open");
      return;
    }
    t.openInstances.push(n), t.emit("register");
  }, this.deregister = function(n) {
    var r = t.openInstances.indexOf(n);
    if (r === -1) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Unable to deregister " + n + " as it was never registered");
      return;
    }
    t.openInstances.splice(r, 1), t.emit("deregister");
  }, this.subscribe = function(n) {
    t.subscribers.push(n);
  }, this.emit = function(n) {
    t.subscribers.forEach(function(r) {
      return r(
        n,
        // shallow copy to avoid accidental mutation
        t.openInstances.slice()
      );
    });
  }, this.openInstances = [], this.subscribers = [];
}, Rt = new Tr();
function As() {
  console.log("portalOpenInstances ----------"), console.log(Rt.openInstances.length), Rt.openInstances.forEach(function(e) {
    return console.log(e);
  }), console.log("end portalOpenInstances ----------");
}
function Ps() {
  Rt = new Tr();
}
tt.default = Rt;
var bn = {};
Object.defineProperty(bn, "__esModule", {
  value: !0
});
bn.resetState = Ds;
bn.log = Ls;
var js = tt, Ns = Ms(js);
function Ms(e) {
  return e && e.__esModule ? e : { default: e };
}
var pe = void 0, Re = void 0, He = [];
function Ds() {
  for (var e = [pe, Re], t = 0; t < e.length; t++) {
    var n = e[t];
    n && n.parentNode && n.parentNode.removeChild(n);
  }
  pe = Re = null, He = [];
}
function Ls() {
  console.log("bodyTrap ----------"), console.log(He.length);
  for (var e = [pe, Re], t = 0; t < e.length; t++) {
    var n = e[t], r = n || {};
    console.log(r.nodeName, r.className, r.id);
  }
  console.log("edn bodyTrap ----------");
}
function Jn() {
  if (He.length === 0) {
    process.env.NODE_ENV !== "production" && console.warn("React-Modal: Open instances > 0 expected");
    return;
  }
  He[He.length - 1].focusContent();
}
function ks(e, t) {
  !pe && !Re && (pe = document.createElement("div"), pe.setAttribute("data-react-modal-body-trap", ""), pe.style.position = "absolute", pe.style.opacity = "0", pe.setAttribute("tabindex", "0"), pe.addEventListener("focus", Jn), Re = pe.cloneNode(), Re.addEventListener("focus", Jn)), He = t, He.length > 0 ? (document.body.firstChild !== pe && document.body.insertBefore(pe, document.body.firstChild), document.body.lastChild !== Re && document.body.appendChild(Re)) : (pe.parentElement && pe.parentElement.removeChild(pe), Re.parentElement && Re.parentElement.removeChild(Re));
}
Ns.default.subscribe(ks);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = Object.assign || function(C) {
    for (var S = 1; S < arguments.length; S++) {
      var M = arguments[S];
      for (var p in M)
        Object.prototype.hasOwnProperty.call(M, p) && (C[p] = M[p]);
    }
    return C;
  }, r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(C) {
    return typeof C;
  } : function(C) {
    return C && typeof Symbol == "function" && C.constructor === Symbol && C !== Symbol.prototype ? "symbol" : typeof C;
  }, o = /* @__PURE__ */ function() {
    function C(S, M) {
      for (var p = 0; p < M.length; p++) {
        var j = M[p];
        j.enumerable = j.enumerable || !1, j.configurable = !0, "value" in j && (j.writable = !0), Object.defineProperty(S, j.key, j);
      }
    }
    return function(S, M, p) {
      return M && C(S.prototype, M), p && C(S, p), S;
    };
  }(), s = Be, a = yn, i = w(a), d = xe, c = N(d), u = rs, f = w(u), v = Ce, O = N(v), m = et, E = N(m), b = Se, A = w(b), P = tt, R = w(P);
  function N(C) {
    if (C && C.__esModule)
      return C;
    var S = {};
    if (C != null)
      for (var M in C)
        Object.prototype.hasOwnProperty.call(C, M) && (S[M] = C[M]);
    return S.default = C, S;
  }
  function w(C) {
    return C && C.__esModule ? C : { default: C };
  }
  function Q(C, S) {
    if (!(C instanceof S))
      throw new TypeError("Cannot call a class as a function");
  }
  function ee(C, S) {
    if (!C)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return S && (typeof S == "object" || typeof S == "function") ? S : C;
  }
  function ae(C, S) {
    if (typeof S != "function" && S !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof S);
    C.prototype = Object.create(S && S.prototype, { constructor: { value: C, enumerable: !1, writable: !0, configurable: !0 } }), S && (Object.setPrototypeOf ? Object.setPrototypeOf(C, S) : C.__proto__ = S);
  }
  var le = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
  }, k = function(S) {
    return S.code === "Tab" || S.keyCode === 9;
  }, H = function(S) {
    return S.code === "Escape" || S.keyCode === 27;
  }, G = 0, z = function(C) {
    ae(S, C);
    function S(M) {
      Q(this, S);
      var p = ee(this, (S.__proto__ || Object.getPrototypeOf(S)).call(this, M));
      return p.setOverlayRef = function(j) {
        p.overlay = j, p.props.overlayRef && p.props.overlayRef(j);
      }, p.setContentRef = function(j) {
        p.content = j, p.props.contentRef && p.props.contentRef(j);
      }, p.afterClose = function() {
        var j = p.props, oe = j.appElement, y = j.ariaHideApp, _ = j.htmlOpenClassName, $ = j.bodyOpenClassName, D = j.parentSelector, L = D && D().ownerDocument || document;
        $ && E.remove(L.body, $), _ && E.remove(L.getElementsByTagName("html")[0], _), y && G > 0 && (G -= 1, G === 0 && O.show(oe)), p.props.shouldFocusAfterRender && (p.props.shouldReturnFocusAfterClose ? (c.returnFocus(p.props.preventScroll), c.teardownScopedFocus()) : c.popWithoutFocus()), p.props.onAfterClose && p.props.onAfterClose(), R.default.deregister(p);
      }, p.open = function() {
        p.beforeOpen(), p.state.afterOpen && p.state.beforeClose ? (clearTimeout(p.closeTimer), p.setState({ beforeClose: !1 })) : (p.props.shouldFocusAfterRender && (c.setupScopedFocus(p.node), c.markForFocusLater()), p.setState({ isOpen: !0 }, function() {
          p.openAnimationFrame = requestAnimationFrame(function() {
            p.setState({ afterOpen: !0 }), p.props.isOpen && p.props.onAfterOpen && p.props.onAfterOpen({
              overlayEl: p.overlay,
              contentEl: p.content
            });
          });
        }));
      }, p.close = function() {
        p.props.closeTimeoutMS > 0 ? p.closeWithTimeout() : p.closeWithoutTimeout();
      }, p.focusContent = function() {
        return p.content && !p.contentHasFocus() && p.content.focus({ preventScroll: !0 });
      }, p.closeWithTimeout = function() {
        var j = Date.now() + p.props.closeTimeoutMS;
        p.setState({ beforeClose: !0, closesAt: j }, function() {
          p.closeTimer = setTimeout(p.closeWithoutTimeout, p.state.closesAt - Date.now());
        });
      }, p.closeWithoutTimeout = function() {
        p.setState({
          beforeClose: !1,
          isOpen: !1,
          afterOpen: !1,
          closesAt: null
        }, p.afterClose);
      }, p.handleKeyDown = function(j) {
        k(j) && (0, f.default)(p.content, j), p.props.shouldCloseOnEsc && H(j) && (j.stopPropagation(), p.requestClose(j));
      }, p.handleOverlayOnClick = function(j) {
        p.shouldClose === null && (p.shouldClose = !0), p.shouldClose && p.props.shouldCloseOnOverlayClick && (p.ownerHandlesClose() ? p.requestClose(j) : p.focusContent()), p.shouldClose = null;
      }, p.handleContentOnMouseUp = function() {
        p.shouldClose = !1;
      }, p.handleOverlayOnMouseDown = function(j) {
        !p.props.shouldCloseOnOverlayClick && j.target == p.overlay && j.preventDefault();
      }, p.handleContentOnClick = function() {
        p.shouldClose = !1;
      }, p.handleContentOnMouseDown = function() {
        p.shouldClose = !1;
      }, p.requestClose = function(j) {
        return p.ownerHandlesClose() && p.props.onRequestClose(j);
      }, p.ownerHandlesClose = function() {
        return p.props.onRequestClose;
      }, p.shouldBeClosed = function() {
        return !p.state.isOpen && !p.state.beforeClose;
      }, p.contentHasFocus = function() {
        return document.activeElement === p.content || p.content.contains(document.activeElement);
      }, p.buildClassName = function(j, oe) {
        var y = (typeof oe > "u" ? "undefined" : r(oe)) === "object" ? oe : {
          base: le[j],
          afterOpen: le[j] + "--after-open",
          beforeClose: le[j] + "--before-close"
        }, _ = y.base;
        return p.state.afterOpen && (_ = _ + " " + y.afterOpen), p.state.beforeClose && (_ = _ + " " + y.beforeClose), typeof oe == "string" && oe ? _ + " " + oe : _;
      }, p.attributesFromObject = function(j, oe) {
        return Object.keys(oe).reduce(function(y, _) {
          return y[j + "-" + _] = oe[_], y;
        }, {});
      }, p.state = {
        afterOpen: !1,
        beforeClose: !1
      }, p.shouldClose = null, p.moveFromContentToOverlay = null, p;
    }
    return o(S, [{
      key: "componentDidMount",
      value: function() {
        this.props.isOpen && this.open();
      }
    }, {
      key: "componentDidUpdate",
      value: function(p, j) {
        process.env.NODE_ENV !== "production" && (p.bodyOpenClassName !== this.props.bodyOpenClassName && console.warn('React-Modal: "bodyOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.'), p.htmlOpenClassName !== this.props.htmlOpenClassName && console.warn('React-Modal: "htmlOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.')), this.props.isOpen && !p.isOpen ? this.open() : !this.props.isOpen && p.isOpen && this.close(), this.props.shouldFocusAfterRender && this.state.isOpen && !j.isOpen && this.focusContent();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.state.isOpen && this.afterClose(), clearTimeout(this.closeTimer), cancelAnimationFrame(this.openAnimationFrame);
      }
    }, {
      key: "beforeOpen",
      value: function() {
        var p = this.props, j = p.appElement, oe = p.ariaHideApp, y = p.htmlOpenClassName, _ = p.bodyOpenClassName, $ = p.parentSelector, D = $ && $().ownerDocument || document;
        _ && E.add(D.body, _), y && E.add(D.getElementsByTagName("html")[0], y), oe && (G += 1, O.hide(j)), R.default.register(this);
      }
      // Don't steal focus from inner elements
    }, {
      key: "render",
      value: function() {
        var p = this.props, j = p.id, oe = p.className, y = p.overlayClassName, _ = p.defaultStyles, $ = p.children, D = oe ? {} : _.content, L = y ? {} : _.overlay;
        if (this.shouldBeClosed())
          return null;
        var J = {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", y),
          style: n({}, L, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        }, U = n({
          id: j,
          ref: this.setContentRef,
          style: n({}, D, this.props.style.content),
          className: this.buildClassName("content", oe),
          tabIndex: "-1",
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleContentOnMouseDown,
          onMouseUp: this.handleContentOnMouseUp,
          onClick: this.handleContentOnClick,
          role: this.props.role,
          "aria-label": this.props.contentLabel
        }, this.attributesFromObject("aria", n({ modal: !0 }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
          "data-testid": this.props.testId
        }), B = this.props.contentElement(U, $);
        return this.props.overlayElement(J, B);
      }
    }]), S;
  }(s.Component);
  z.defaultProps = {
    style: {
      overlay: {},
      content: {}
    },
    defaultStyles: {}
  }, z.propTypes = {
    isOpen: i.default.bool.isRequired,
    defaultStyles: i.default.shape({
      content: i.default.object,
      overlay: i.default.object
    }),
    style: i.default.shape({
      content: i.default.object,
      overlay: i.default.object
    }),
    className: i.default.oneOfType([i.default.string, i.default.object]),
    overlayClassName: i.default.oneOfType([i.default.string, i.default.object]),
    parentSelector: i.default.func,
    bodyOpenClassName: i.default.string,
    htmlOpenClassName: i.default.string,
    ariaHideApp: i.default.bool,
    appElement: i.default.oneOfType([i.default.instanceOf(A.default), i.default.instanceOf(b.SafeHTMLCollection), i.default.instanceOf(b.SafeNodeList), i.default.arrayOf(i.default.instanceOf(A.default))]),
    onAfterOpen: i.default.func,
    onAfterClose: i.default.func,
    onRequestClose: i.default.func,
    closeTimeoutMS: i.default.number,
    shouldFocusAfterRender: i.default.bool,
    shouldCloseOnOverlayClick: i.default.bool,
    shouldReturnFocusAfterClose: i.default.bool,
    preventScroll: i.default.bool,
    role: i.default.string,
    contentLabel: i.default.string,
    aria: i.default.object,
    data: i.default.object,
    children: i.default.node,
    shouldCloseOnEsc: i.default.bool,
    overlayRef: i.default.func,
    contentRef: i.default.func,
    id: i.default.string,
    overlayElement: i.default.func,
    contentElement: i.default.func,
    testId: i.default.string
  }, t.default = z, e.exports = t.default;
})(tn, tn.exports);
var $s = tn.exports;
function xr() {
  var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
  e != null && this.setState(e);
}
function Cr(e) {
  function t(n) {
    var r = this.constructor.getDerivedStateFromProps(e, n);
    return r ?? null;
  }
  this.setState(t.bind(this));
}
function Ar(e, t) {
  try {
    var n = this.props, r = this.state;
    this.props = e, this.state = t, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      n,
      r
    );
  } finally {
    this.props = n, this.state = r;
  }
}
xr.__suppressDeprecationWarning = !0;
Cr.__suppressDeprecationWarning = !0;
Ar.__suppressDeprecationWarning = !0;
function Fs(e) {
  var t = e.prototype;
  if (!t || !t.isReactComponent)
    throw new Error("Can only polyfill class components");
  if (typeof e.getDerivedStateFromProps != "function" && typeof t.getSnapshotBeforeUpdate != "function")
    return e;
  var n = null, r = null, o = null;
  if (typeof t.componentWillMount == "function" ? n = "componentWillMount" : typeof t.UNSAFE_componentWillMount == "function" && (n = "UNSAFE_componentWillMount"), typeof t.componentWillReceiveProps == "function" ? r = "componentWillReceiveProps" : typeof t.UNSAFE_componentWillReceiveProps == "function" && (r = "UNSAFE_componentWillReceiveProps"), typeof t.componentWillUpdate == "function" ? o = "componentWillUpdate" : typeof t.UNSAFE_componentWillUpdate == "function" && (o = "UNSAFE_componentWillUpdate"), n !== null || r !== null || o !== null) {
    var s = e.displayName || e.name, a = typeof e.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(
      `Unsafe legacy lifecycles will not be called for components using new component APIs.

` + s + " uses " + a + " but also contains the following legacy lifecycles:" + (n !== null ? `
  ` + n : "") + (r !== null ? `
  ` + r : "") + (o !== null ? `
  ` + o : "") + `

The above lifecycles should be removed. Learn more about this warning here:
https://fb.me/react-async-component-lifecycle-hooks`
    );
  }
  if (typeof e.getDerivedStateFromProps == "function" && (t.componentWillMount = xr, t.componentWillReceiveProps = Cr), typeof t.getSnapshotBeforeUpdate == "function") {
    if (typeof t.componentDidUpdate != "function")
      throw new Error(
        "Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype"
      );
    t.componentWillUpdate = Ar;
    var i = t.componentDidUpdate;
    t.componentDidUpdate = function(c, u, f) {
      var v = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : f;
      i.call(this, c, u, v);
    };
  }
  return e;
}
const Is = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  polyfill: Fs
}, Symbol.toStringTag, { value: "Module" })), Us = /* @__PURE__ */ Lo(Is);
Object.defineProperty(Ve, "__esModule", {
  value: !0
});
Ve.bodyOpenClassName = Ve.portalClassName = void 0;
var Kn = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
  }
  return e;
}, Bs = /* @__PURE__ */ function() {
  function e(t, n) {
    for (var r = 0; r < n.length; r++) {
      var o = n[r];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
    }
  }
  return function(t, n, r) {
    return n && e(t.prototype, n), r && e(t, r), t;
  };
}(), Pr = Be, St = mt(Pr), qs = Do, Tt = mt(qs), Ws = yn, I = mt(Ws), Hs = $s, Xn = mt(Hs), Gs = Ce, Vs = zs(Gs), De = Se, Zn = mt(De), Ys = Us;
function zs(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
  return t.default = e, t;
}
function mt(e) {
  return e && e.__esModule ? e : { default: e };
}
function Js(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Qn(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function Ks(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var Xs = Ve.portalClassName = "ReactModalPortal", Zs = Ve.bodyOpenClassName = "ReactModal__Body--open", Fe = De.canUseDOM && Tt.default.createPortal !== void 0, sn = function(t) {
  return document.createElement(t);
}, er = function() {
  return Fe ? Tt.default.createPortal : Tt.default.unstable_renderSubtreeIntoContainer;
};
function Et(e) {
  return e();
}
var nt = function(e) {
  Ks(t, e);
  function t() {
    var n, r, o, s;
    Js(this, t);
    for (var a = arguments.length, i = Array(a), d = 0; d < a; d++)
      i[d] = arguments[d];
    return s = (r = (o = Qn(this, (n = t.__proto__ || Object.getPrototypeOf(t)).call.apply(n, [this].concat(i))), o), o.removePortal = function() {
      !Fe && Tt.default.unmountComponentAtNode(o.node);
      var c = Et(o.props.parentSelector);
      c && c.contains(o.node) ? c.removeChild(o.node) : console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
    }, o.portalRef = function(c) {
      o.portal = c;
    }, o.renderPortal = function(c) {
      var u = er(), f = u(o, St.default.createElement(Xn.default, Kn({ defaultStyles: t.defaultStyles }, c)), o.node);
      o.portalRef(f);
    }, r), Qn(o, s);
  }
  return Bs(t, [{
    key: "componentDidMount",
    value: function() {
      if (De.canUseDOM) {
        Fe || (this.node = sn("div")), this.node.className = this.props.portalClassName;
        var r = Et(this.props.parentSelector);
        r.appendChild(this.node), !Fe && this.renderPortal(this.props);
      }
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function(r) {
      var o = Et(r.parentSelector), s = Et(this.props.parentSelector);
      return { prevParent: o, nextParent: s };
    }
  }, {
    key: "componentDidUpdate",
    value: function(r, o, s) {
      if (De.canUseDOM) {
        var a = this.props, i = a.isOpen, d = a.portalClassName;
        r.portalClassName !== d && (this.node.className = d);
        var c = s.prevParent, u = s.nextParent;
        u !== c && (c.removeChild(this.node), u.appendChild(this.node)), !(!r.isOpen && !i) && !Fe && this.renderPortal(this.props);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      if (!(!De.canUseDOM || !this.node || !this.portal)) {
        var r = this.portal.state, o = Date.now(), s = r.isOpen && this.props.closeTimeoutMS && (r.closesAt || o + this.props.closeTimeoutMS);
        s ? (r.beforeClose || this.portal.closeWithTimeout(), setTimeout(this.removePortal, s - o)) : this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function() {
      if (!De.canUseDOM || !Fe)
        return null;
      !this.node && Fe && (this.node = sn("div"));
      var r = er();
      return r(St.default.createElement(Xn.default, Kn({
        ref: this.portalRef,
        defaultStyles: t.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function(r) {
      Vs.setElement(r);
    }
    /* eslint-disable react/no-unused-prop-types */
    /* eslint-enable react/no-unused-prop-types */
  }]), t;
}(Pr.Component);
nt.propTypes = {
  isOpen: I.default.bool.isRequired,
  style: I.default.shape({
    content: I.default.object,
    overlay: I.default.object
  }),
  portalClassName: I.default.string,
  bodyOpenClassName: I.default.string,
  htmlOpenClassName: I.default.string,
  className: I.default.oneOfType([I.default.string, I.default.shape({
    base: I.default.string.isRequired,
    afterOpen: I.default.string.isRequired,
    beforeClose: I.default.string.isRequired
  })]),
  overlayClassName: I.default.oneOfType([I.default.string, I.default.shape({
    base: I.default.string.isRequired,
    afterOpen: I.default.string.isRequired,
    beforeClose: I.default.string.isRequired
  })]),
  appElement: I.default.oneOfType([I.default.instanceOf(Zn.default), I.default.instanceOf(De.SafeHTMLCollection), I.default.instanceOf(De.SafeNodeList), I.default.arrayOf(I.default.instanceOf(Zn.default))]),
  onAfterOpen: I.default.func,
  onRequestClose: I.default.func,
  closeTimeoutMS: I.default.number,
  ariaHideApp: I.default.bool,
  shouldFocusAfterRender: I.default.bool,
  shouldCloseOnOverlayClick: I.default.bool,
  shouldReturnFocusAfterClose: I.default.bool,
  preventScroll: I.default.bool,
  parentSelector: I.default.func,
  aria: I.default.object,
  data: I.default.object,
  role: I.default.string,
  contentLabel: I.default.string,
  shouldCloseOnEsc: I.default.bool,
  overlayRef: I.default.func,
  contentRef: I.default.func,
  id: I.default.string,
  overlayElement: I.default.func,
  contentElement: I.default.func
};
nt.defaultProps = {
  isOpen: !1,
  portalClassName: Xs,
  bodyOpenClassName: Zs,
  role: "dialog",
  ariaHideApp: !0,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: !0,
  shouldCloseOnEsc: !0,
  shouldCloseOnOverlayClick: !0,
  shouldReturnFocusAfterClose: !0,
  preventScroll: !1,
  parentSelector: function() {
    return document.body;
  },
  overlayElement: function(t, n) {
    return St.default.createElement(
      "div",
      t,
      n
    );
  },
  contentElement: function(t, n) {
    return St.default.createElement(
      "div",
      t,
      n
    );
  }
};
nt.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};
(0, Ys.polyfill)(nt);
process.env.NODE_ENV !== "production" && (nt.setCreateHTMLElement = function(e) {
  return sn = e;
});
Ve.default = nt;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = Ve, r = o(n);
  function o(s) {
    return s && s.__esModule ? s : { default: s };
  }
  t.default = r.default, e.exports = t.default;
})(Qt, Qt.exports);
var Qs = Qt.exports;
const tr = /* @__PURE__ */ hn(Qs);
function jr() {
  return (jr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
function ea(e, t) {
  if (e == null) return {};
  var n, r, o = function(a, i) {
    if (a == null) return {};
    var d, c, u = {}, f = Object.keys(a);
    for (c = 0; c < f.length; c++) d = f[c], i.indexOf(d) >= 0 || (u[d] = a[d]);
    return u;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) n = s[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
  }
  return o;
}
var ta = ["aria-disabled", "aria-haspopup", "aria-expanded", "aria-pressed"].concat(["aria-atomic", "aria-braillelabel", "aria-brailleroledescription", "aria-controls", "aria-describedby", "aria-description", "aria-details", "aria-dropeffect", "aria-flowto", "aria-keyshortcuts", "aria-label", "aria-labelledby", "aria-live", "aria-owns", "aria-relevant", "aria-roledescription", "aria-busy", "aria-current", "aria-grabbed", "aria-hidden"]), wt = function(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  return n.flat().reduce(function(o, s) {
    return e && Object.prototype.hasOwnProperty.call(e, s) && (o[s] = e[s]), o;
  }, {});
}, na = ["as", "children", "className", "disabled", "elevation", "icon", "iconPosition", "label", "oval", "size", "tabIndex", "variant"], Nr = { default: "", "plus-1": "type-scale-1", "plus-2": "type-scale-2", "minus-1": "type-scale-minus-1" }, ra = ["primary", "secondary", "multipurpose", "blue", "green", "red", "ghost", "primary-dark", "secondary-dark"], Mr = { flat: "", raised: "btn-raised" }, oa = { as: _e.oneOf(["button", "a"]), children: _e.node, className: _e.string, disabled: _e.bool, elevation: _e.oneOf(Object.keys(Mr)), icon: _e.string, iconPosition: _e.oneOf(["left", "right"]), label: _e.string, oval: _e.bool, size: _e.oneOf(Object.keys(Nr)), tabIndex: _e.number, variant: _e.oneOf(ra) }, Qe = jo(function(e, t) {
  var n = e.as, r = e.children, o = e.className, s = e.disabled, a = e.elevation, i = e.icon, d = e.iconPosition, c = e.label, u = e.oval, f = e.size, v = e.tabIndex, O = e.variant, m = ea(e, na), E = ie("btn", "rhythm-button", Nr[f], u && "btn-oval", O && "btn-".concat(O), Mr[a], o), b = n === "button" ? "button" : null, A = wt(m, ta, n === "a" && ["href", "target"]), P = wt(m, ["onBlur", "onFocus"]), R = wt(m, ["onKeyDown", "onKeyUp"]), N = wt(m, ["onClick", "onMouseDown", "onMouseEnter", "onMouseLeave", "onMouseOver", "onMouseUp"]);
  return Be.createElement(n, jr({ ref: t, type: b, className: E, disabled: s, onClick: N.onClick, onBlur: P.onBlur, onFocus: P.onFocus, onKeyDown: R.onKeyDown, onKeyUp: R.onKeyUp, onMouseDown: N.onMouseDown, onMouseEnter: N.onMouseEnter, onMouseLeave: N.onMouseLeave, onMouseOver: N.onMouseOver, onMouseUp: N.onMouseUp, tabIndex: v }, A), i && d === "left" && Be.createElement("i", { className: i, "aria-hidden": "true" }), r || c, i && d === "right" && Be.createElement("i", { className: ie(i, "btn-icon-right"), "aria-hidden": "true" }));
});
Qe.defaultProps = { as: "button", children: "", className: "", disabled: !1, elevation: "flat", icon: "", iconPosition: "left", label: "", oval: !1, size: "default", tabIndex: null, variant: "primary" }, Qe.propTypes = oa, Qe.displayName = "Button";
const sa = "#fff", aa = "#f8f8f8", ia = "#e9e9e9", la = "#f2f2f2", ca = "#e8e8e8", ua = "#7f7f7f", fa = "#979797", da = "#a8a8a8", pa = "#d8d8d8", ha = "#666", ma = "#3b3b3b", ya = "#676767", va = "#929292", ba = "#262626", ga = "#2b2b2b", Ea = "#464646", wa = "#bdbdbd", _a = "#f37321", Oa = "#bf5c26", Ra = "#ced9df", Sa = "#09c", Ta = "#3278c8", xa = "#ebf2fa", Ca = "#c0e1d3", Aa = "#02b88c", Pa = "#00866b", ja = "#e7d5d5", Na = "#ab0303", Ma = "#db2e00", Da = "#da4a22", La = "#fbeae6", ka = "#a43819", $a = "#832c14", Fa = "#e8f6ff", Ia = "#ede2c3", Ua = "#ffc80a", Ba = "#f5e8c0", qa = "#fefbe0", Wa = "#9c0d63", Ha = "#5e083b", Ga = "#2f041e", Va = "#f5e7ef", Ya = "#ebf2fa", za = "#c2d7ef", Ja = "#f6f6f6", Ka = "_opened_xyqkw_49", ut = {
  white: sa,
  liteGray: aa,
  brightGray: ia,
  gray: la,
  shadeGray: ca,
  logoGray: ua,
  abbey: fa,
  buttonGray: da,
  scrollbarGray: pa,
  darkGray: ha,
  textGray: ma,
  placeholderGray: ya,
  permGray: va,
  black: ba,
  textBlack: ga,
  dividerBlack: Ea,
  silver: wa,
  main: _a,
  mainDark: Oa,
  liteBlue: Ra,
  blue: Sa,
  mariner: Ta,
  blueMessage: xa,
  liteGreen: Ca,
  green: Aa,
  greenMessage: Pa,
  liteRed: ja,
  red: Na,
  errorRed: Ma,
  googleRed: Da,
  redLightest: La,
  googleRedHover: ka,
  googleRedActive: $a,
  highlightBlue: Fa,
  liteYellow: Ia,
  yellow: Ua,
  yellowWarning: Ba,
  yellowRequest: qa,
  plumColor: Wa,
  darkPlum: Ha,
  darkerPlum: Ga,
  plumLightest: Va,
  linkWater: Ya,
  lightBlue: za,
  pale: Ja,
  "modal-portal": "_modal-portal_xyqkw_49",
  opened: Ka,
  "modal-overlay": "_modal-overlay_xyqkw_55",
  "modal-body": "_modal-body_xyqkw_62",
  "modal-close-button": "_modal-close-button_xyqkw_75"
}, Xa = ({
  isOpen: e,
  children: t,
  onClose: n,
  className: r = "",
  closeButtonClassName: o = "",
  appElementId: s,
  closable: a = !0,
  ...i
}) => (tr.setAppElement(s), /* @__PURE__ */ W.jsxs(
  tr,
  {
    isOpen: e,
    overlayClassName: ut["modal-overlay"],
    portalClassName: ie(
      ut["modal-portal"],
      e && ut.opened
    ),
    className: ie(ut["modal-body"], r),
    onRequestClose: n,
    shouldCloseOnEsc: a,
    shouldCloseOnOverlayClick: a,
    ...i,
    children: [
      a && /* @__PURE__ */ W.jsx(
        Qe,
        {
          "aria-label": "Close Modal",
          onClick: n,
          className: ie(
            ut["modal-close-button"],
            o
          ),
          oval: !0,
          icon: "icon-v2-close",
          variant: "ghost"
        }
      ),
      t
    ]
  }
));
var Za = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(br, () => {
    return n = { 772: (o, s, a) => {
      const i = a(826).remove, d = /[.*+?^${}()|[\]\\]/g, c = /[a-z0-9_]/i, u = /\s+/;
      o.exports = function(f, v, O) {
        var m, E;
        E = { insideWords: !1, findAllOccurrences: !1, requireMatchAll: !1 }, m = (m = O) || {}, Object.keys(m).forEach((P) => {
          E[P] = !!m[P];
        }), O = E;
        const b = Array.from(f).map((P) => i(P));
        let A = b.join("");
        return (v = i(v)).trim().split(u).filter((P) => P.length > 0).reduce((P, R) => {
          const N = R.length, w = !O.insideWords && c.test(R[0]) ? "\\b" : "", Q = new RegExp(w + R.replace(d, "\\$&"), "i");
          let ee, ae;
          if (ee = Q.exec(A), O.requireMatchAll && ee === null) return A = "", [];
          for (; ee; ) {
            ae = ee.index;
            const le = N - b.slice(ae, ae + N).join("").length, k = ae - b.slice(0, ae).join("").length, H = [ae + k, ae + N + k + le];
            if (H[0] !== H[1] && P.push(H), A = A.slice(0, ae) + new Array(N + 1).join(" ") + A.slice(ae + N), !O.findAllOccurrences) break;
            ee = Q.exec(A);
          }
          return P;
        }, []).sort((P, R) => P[0] - R[0]);
      };
    }, 826: (o) => {
      var s = { À: "A", Á: "A", Â: "A", Ã: "A", Ä: "A", Å: "A", Ấ: "A", Ắ: "A", Ẳ: "A", Ẵ: "A", Ặ: "A", Æ: "AE", Ầ: "A", Ằ: "A", Ȃ: "A", Ç: "C", Ḉ: "C", È: "E", É: "E", Ê: "E", Ë: "E", Ế: "E", Ḗ: "E", Ề: "E", Ḕ: "E", Ḝ: "E", Ȇ: "E", Ì: "I", Í: "I", Î: "I", Ï: "I", Ḯ: "I", Ȋ: "I", Ð: "D", Ñ: "N", Ò: "O", Ó: "O", Ô: "O", Õ: "O", Ö: "O", Ø: "O", Ố: "O", Ṍ: "O", Ṓ: "O", Ȏ: "O", Ù: "U", Ú: "U", Û: "U", Ü: "U", Ý: "Y", à: "a", á: "a", â: "a", ã: "a", ä: "a", å: "a", ấ: "a", ắ: "a", ẳ: "a", ẵ: "a", ặ: "a", æ: "ae", ầ: "a", ằ: "a", ȃ: "a", ç: "c", ḉ: "c", è: "e", é: "e", ê: "e", ë: "e", ế: "e", ḗ: "e", ề: "e", ḕ: "e", ḝ: "e", ȇ: "e", ì: "i", í: "i", î: "i", ï: "i", ḯ: "i", ȋ: "i", ð: "d", ñ: "n", ò: "o", ó: "o", ô: "o", õ: "o", ö: "o", ø: "o", ố: "o", ṍ: "o", ṓ: "o", ȏ: "o", ù: "u", ú: "u", û: "u", ü: "u", ý: "y", ÿ: "y", Ā: "A", ā: "a", Ă: "A", ă: "a", Ą: "A", ą: "a", Ć: "C", ć: "c", Ĉ: "C", ĉ: "c", Ċ: "C", ċ: "c", Č: "C", č: "c", C̆: "C", c̆: "c", Ď: "D", ď: "d", Đ: "D", đ: "d", Ē: "E", ē: "e", Ĕ: "E", ĕ: "e", Ė: "E", ė: "e", Ę: "E", ę: "e", Ě: "E", ě: "e", Ĝ: "G", Ǵ: "G", ĝ: "g", ǵ: "g", Ğ: "G", ğ: "g", Ġ: "G", ġ: "g", Ģ: "G", ģ: "g", Ĥ: "H", ĥ: "h", Ħ: "H", ħ: "h", Ḫ: "H", ḫ: "h", Ĩ: "I", ĩ: "i", Ī: "I", ī: "i", Ĭ: "I", ĭ: "i", Į: "I", į: "i", İ: "I", ı: "i", Ĳ: "IJ", ĳ: "ij", Ĵ: "J", ĵ: "j", Ķ: "K", ķ: "k", Ḱ: "K", ḱ: "k", K̆: "K", k̆: "k", Ĺ: "L", ĺ: "l", Ļ: "L", ļ: "l", Ľ: "L", ľ: "l", Ŀ: "L", ŀ: "l", Ł: "l", ł: "l", Ḿ: "M", ḿ: "m", M̆: "M", m̆: "m", Ń: "N", ń: "n", Ņ: "N", ņ: "n", Ň: "N", ň: "n", ŉ: "n", N̆: "N", n̆: "n", Ō: "O", ō: "o", Ŏ: "O", ŏ: "o", Ő: "O", ő: "o", Œ: "OE", œ: "oe", P̆: "P", p̆: "p", Ŕ: "R", ŕ: "r", Ŗ: "R", ŗ: "r", Ř: "R", ř: "r", R̆: "R", r̆: "r", Ȓ: "R", ȓ: "r", Ś: "S", ś: "s", Ŝ: "S", ŝ: "s", Ş: "S", Ș: "S", ș: "s", ş: "s", Š: "S", š: "s", Ţ: "T", ţ: "t", ț: "t", Ț: "T", Ť: "T", ť: "t", Ŧ: "T", ŧ: "t", T̆: "T", t̆: "t", Ũ: "U", ũ: "u", Ū: "U", ū: "u", Ŭ: "U", ŭ: "u", Ů: "U", ů: "u", Ű: "U", ű: "u", Ų: "U", ų: "u", Ȗ: "U", ȗ: "u", V̆: "V", v̆: "v", Ŵ: "W", ŵ: "w", Ẃ: "W", ẃ: "w", X̆: "X", x̆: "x", Ŷ: "Y", ŷ: "y", Ÿ: "Y", Y̆: "Y", y̆: "y", Ź: "Z", ź: "z", Ż: "Z", ż: "z", Ž: "Z", ž: "z", ſ: "s", ƒ: "f", Ơ: "O", ơ: "o", Ư: "U", ư: "u", Ǎ: "A", ǎ: "a", Ǐ: "I", ǐ: "i", Ǒ: "O", ǒ: "o", Ǔ: "U", ǔ: "u", Ǖ: "U", ǖ: "u", Ǘ: "U", ǘ: "u", Ǚ: "U", ǚ: "u", Ǜ: "U", ǜ: "u", Ứ: "U", ứ: "u", Ṹ: "U", ṹ: "u", Ǻ: "A", ǻ: "a", Ǽ: "AE", ǽ: "ae", Ǿ: "O", ǿ: "o", Þ: "TH", þ: "th", Ṕ: "P", ṕ: "p", Ṥ: "S", ṥ: "s", X́: "X", x́: "x", Ѓ: "Г", ѓ: "г", Ќ: "К", ќ: "к", A̋: "A", a̋: "a", E̋: "E", e̋: "e", I̋: "I", i̋: "i", Ǹ: "N", ǹ: "n", Ồ: "O", ồ: "o", Ṑ: "O", ṑ: "o", Ừ: "U", ừ: "u", Ẁ: "W", ẁ: "w", Ỳ: "Y", ỳ: "y", Ȁ: "A", ȁ: "a", Ȅ: "E", ȅ: "e", Ȉ: "I", ȉ: "i", Ȍ: "O", ȍ: "o", Ȑ: "R", ȑ: "r", Ȕ: "U", ȕ: "u", B̌: "B", b̌: "b", Č̣: "C", č̣: "c", Ê̌: "E", ê̌: "e", F̌: "F", f̌: "f", Ǧ: "G", ǧ: "g", Ȟ: "H", ȟ: "h", J̌: "J", ǰ: "j", Ǩ: "K", ǩ: "k", M̌: "M", m̌: "m", P̌: "P", p̌: "p", Q̌: "Q", q̌: "q", Ř̩: "R", ř̩: "r", Ṧ: "S", ṧ: "s", V̌: "V", v̌: "v", W̌: "W", w̌: "w", X̌: "X", x̌: "x", Y̌: "Y", y̌: "y", A̧: "A", a̧: "a", B̧: "B", b̧: "b", Ḑ: "D", ḑ: "d", Ȩ: "E", ȩ: "e", Ɛ̧: "E", ɛ̧: "e", Ḩ: "H", ḩ: "h", I̧: "I", i̧: "i", Ɨ̧: "I", ɨ̧: "i", M̧: "M", m̧: "m", O̧: "O", o̧: "o", Q̧: "Q", q̧: "q", U̧: "U", u̧: "u", X̧: "X", x̧: "x", Z̧: "Z", z̧: "z" }, a = Object.keys(s).join("|"), i = new RegExp(a, "g"), d = new RegExp(a, ""), c = function(u) {
        return u.replace(i, function(f) {
          return s[f];
        });
      };
      o.exports = c, o.exports.has = function(u) {
        return !!u.match(d);
      }, o.exports.remove = c;
    } }, r = {}, function o(s) {
      var a = r[s];
      if (a !== void 0) return a.exports;
      var i = r[s] = { exports: {} };
      return n[s](i, i.exports, o), i.exports;
    }(772);
    var n, r;
  });
})(Za);
var Qa = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(br, () => {
    return n = { 705: (o) => {
      o.exports = function(s, a) {
        const i = [];
        return a.length === 0 ? i.push({ text: s, highlight: !1 }) : a[0][0] > 0 && i.push({ text: s.slice(0, a[0][0]), highlight: !1 }), a.forEach((d, c) => {
          const u = d[0], f = d[1];
          i.push({ text: s.slice(u, f), highlight: !0 }), c === a.length - 1 ? f < s.length && i.push({ text: s.slice(f, s.length), highlight: !1 }) : f < a[c + 1][0] && i.push({ text: s.slice(f, a[c + 1][0]), highlight: !1 });
        }), i;
      };
    } }, r = {}, function o(s) {
      var a = r[s];
      if (a !== void 0) return a.exports;
      var i = r[s] = { exports: {} };
      return n[s](i, i.exports, o), i.exports;
    }(705);
    var n, r;
  });
})(Qa);
var Dr = /* @__PURE__ */ ((e) => (e.amplifyEnrollment = "amplify-enrollment", e.singleSession = "single-session", e))(Dr || {});
const ei = "#fff", ti = "#f8f8f8", ni = "#e9e9e9", ri = "#f2f2f2", oi = "#e8e8e8", si = "#7f7f7f", ai = "#979797", ii = "#a8a8a8", li = "#d8d8d8", ci = "#666", ui = "#3b3b3b", fi = "#676767", di = "#929292", pi = "#262626", hi = "#2b2b2b", mi = "#464646", yi = "#bdbdbd", vi = "#f37321", bi = "#bf5c26", gi = "#ced9df", Ei = "#09c", wi = "#3278c8", _i = "#ebf2fa", Oi = "#c0e1d3", Ri = "#02b88c", Si = "#00866b", Ti = "#e7d5d5", xi = "#ab0303", Ci = "#db2e00", Ai = "#da4a22", Pi = "#fbeae6", ji = "#a43819", Ni = "#832c14", Mi = "#e8f6ff", Di = "#ede2c3", Li = "#ffc80a", ki = "#f5e8c0", $i = "#fefbe0", Fi = "#9c0d63", Ii = "#5e083b", Ui = "#2f041e", Bi = "#f5e7ef", qi = "#ebf2fa", Wi = "#c2d7ef", Hi = "#f6f6f6", Gi = "_dots_1w2om_104", Vi = "_dots__item_1w2om_111", Yi = "_flow_1w2om_1", zi = "_shake_1w2om_1", Ji = "_spinner_1w2om_1", Ki = "_spin_1w2om_1", je = {
  white: ei,
  liteGray: ti,
  brightGray: ni,
  gray: ri,
  shadeGray: oi,
  logoGray: si,
  abbey: ai,
  buttonGray: ii,
  scrollbarGray: li,
  darkGray: ci,
  textGray: ui,
  placeholderGray: fi,
  permGray: di,
  black: pi,
  textBlack: hi,
  dividerBlack: mi,
  silver: yi,
  main: vi,
  mainDark: bi,
  liteBlue: gi,
  blue: Ei,
  mariner: wi,
  blueMessage: _i,
  liteGreen: Oi,
  green: Ri,
  greenMessage: Si,
  liteRed: Ti,
  red: xi,
  errorRed: Ci,
  googleRed: Ai,
  redLightest: Pi,
  googleRedHover: ji,
  googleRedActive: Ni,
  highlightBlue: Mi,
  liteYellow: Di,
  yellow: Li,
  yellowWarning: ki,
  yellowRequest: $i,
  plumColor: Fi,
  darkPlum: Ii,
  darkerPlum: Ui,
  plumLightest: Bi,
  linkWater: qi,
  lightBlue: Wi,
  pale: Hi,
  dots: Gi,
  dots__item: Vi,
  flow: Yi,
  "dots-success": "_dots-success_1w2om_125",
  "dots-success__item": "_dots-success__item_1w2om_131",
  shake: zi,
  "shake-reverse": "_shake-reverse_1w2om_1",
  spinner: Ji,
  spin: Ki
}, Xi = ({ externalClassName: e }) => /* @__PURE__ */ W.jsxs(
  "div",
  {
    className: ie(
      je.dots,
      e && je[`dots-${e}`]
    ),
    "data-testid": "dots-loader",
    children: [
      /* @__PURE__ */ W.jsx(
        "div",
        {
          className: ie(
            je.dots__item,
            e && je[`dots-${e}__item`]
          )
        }
      ),
      /* @__PURE__ */ W.jsx(
        "div",
        {
          className: ie(
            je.dots__item,
            e && je[`dots-${e}__item`]
          )
        }
      ),
      /* @__PURE__ */ W.jsx(
        "div",
        {
          className: ie(
            je.dots__item,
            e && je[`dots-${e}__item`]
          )
        }
      )
    ]
  }
), Zi = "#fff", Qi = "#f8f8f8", el = "#e9e9e9", tl = "#f2f2f2", nl = "#e8e8e8", rl = "#7f7f7f", ol = "#979797", sl = "#a8a8a8", al = "#d8d8d8", il = "#666", ll = "#3b3b3b", cl = "#676767", ul = "#929292", fl = "#262626", dl = "#2b2b2b", pl = "#464646", hl = "#bdbdbd", ml = "#f37321", yl = "#bf5c26", vl = "#ced9df", bl = "#09c", gl = "#3278c8", El = "#ebf2fa", wl = "#c0e1d3", _l = "#02b88c", Ol = "#00866b", Rl = "#e7d5d5", Sl = "#ab0303", Tl = "#db2e00", xl = "#da4a22", Cl = "#fbeae6", Al = "#a43819", Pl = "#832c14", jl = "#e8f6ff", Nl = "#ede2c3", Ml = "#ffc80a", Dl = "#f5e8c0", Ll = "#fefbe0", kl = "#9c0d63", $l = "#5e083b", Fl = "#2f041e", Il = "#f5e7ef", Ul = "#ebf2fa", Bl = "#c2d7ef", ql = "#f6f6f6", Wl = "_hover_o86dm_164", Hl = "_valid_o86dm_168", Gl = "_invalid_o86dm_172", Vl = "_shake_o86dm_1", Yl = "_flow_o86dm_1", zl = "_spinner_o86dm_1", Jl = "_spin_o86dm_1", Le = {
  white: Zi,
  liteGray: Qi,
  brightGray: el,
  gray: tl,
  shadeGray: nl,
  logoGray: rl,
  abbey: ol,
  buttonGray: sl,
  scrollbarGray: al,
  darkGray: il,
  textGray: ll,
  placeholderGray: cl,
  permGray: ul,
  black: fl,
  textBlack: dl,
  dividerBlack: pl,
  silver: hl,
  main: ml,
  mainDark: yl,
  liteBlue: vl,
  blue: bl,
  mariner: gl,
  blueMessage: El,
  liteGreen: wl,
  green: _l,
  greenMessage: Ol,
  liteRed: Rl,
  red: Sl,
  errorRed: Tl,
  googleRed: xl,
  redLightest: Cl,
  googleRedHover: Al,
  googleRedActive: Pl,
  highlightBlue: jl,
  liteYellow: Nl,
  yellow: Ml,
  yellowWarning: Dl,
  yellowRequest: Ll,
  plumColor: kl,
  darkPlum: $l,
  darkerPlum: Fl,
  plumLightest: Il,
  linkWater: Ul,
  lightBlue: Bl,
  pale: ql,
  "join-code-input-wrapper": "_join-code-input-wrapper_o86dm_104",
  "join-code-input": "_join-code-input_o86dm_104",
  hover: Wl,
  valid: Hl,
  invalid: Gl,
  shake: Vl,
  "shake-reverse": "_shake-reverse_o86dm_1",
  "join-code-input-validation-msg": "_join-code-input-validation-msg_o86dm_182",
  flow: Yl,
  spinner: zl,
  spin: Jl
}, Kl = ({
  codeType: e,
  isCodeValid: t,
  isAuthed: n,
  isOnJoin: r,
  isJoiningClass: o,
  isCodeExpired: s,
  userNotAllowed: a
}) => t && a ? /* @__PURE__ */ W.jsxs(
  "div",
  {
    className: ie(
      Le["join-code-input-validation-msg"],
      Le.invalid,
      "join-code-input"
    ),
    children: [
      /* @__PURE__ */ W.jsx("i", { className: "icon-v2-messaging-warning" }),
      "Teachers cannot enroll in classes as a student."
    ]
  }
) : r && t && e === Dr.amplifyEnrollment && (n && !o || !n) || t === null ? null : /* @__PURE__ */ W.jsx(
  "div",
  {
    className: ie(
      Le["join-code-input-validation-msg"],
      Le[t ? "valid" : "invalid"],
      "join-code-input"
    ),
    "data-testid": "join-code-input-msg",
    children: t ? /* @__PURE__ */ W.jsxs(W.Fragment, { children: [
      /* @__PURE__ */ W.jsx("i", { className: "icon-v2-messaging-success" }),
      "Success! Joining",
      /* @__PURE__ */ W.jsx(Xi, { externalClassName: "success" })
    ] }) : /* @__PURE__ */ W.jsxs(W.Fragment, { children: [
      /* @__PURE__ */ W.jsx("i", { className: "icon-v2-messaging-warning" }),
      s ? "Sorry, this code has expired." : "Oops... Try again!"
    ] })
  }
), Xl = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/, me = 6, nr = new Array(me).fill(""), Zl = 1e3, Ql = ({
  codeValue: e,
  setCodeValue: t,
  isValid: n,
  codeType: r,
  isAuthed: o,
  isOnJoin: s,
  isJoiningClass: a,
  codeFromUrl: i,
  onStoryChange: d,
  isCodeExpired: c,
  setCodeInfo: u,
  userNotAllowed: f
}) => {
  const [v, O] = Pe(
    () => (i == null ? void 0 : i.length) === me ? i.split("") : nr
  ), m = Bt(
    (i == null ? void 0 : i.length) === me ? me - 1 : 0
  ), E = No(
    () => Array.from({ length: me }, () => Mo()),
    []
  ), [b, A] = Pe(
    null
  ), P = Bt(), R = Bt(null), N = (k) => {
    var M;
    k.preventDefault(), A(null);
    const G = k.clipboardData.getData("text/plain").replace(Xl, "").split("");
    for (; G.length < me; )
      G.push("");
    O(G.slice(0, me));
    const z = G.indexOf(""), C = z > -1 ? z : me - 1, S = (M = E[C]) == null ? void 0 : M.current;
    m.current = C, S == null || S.select(), S == null || S.focus();
  }, w = (k, H) => {
    A(null), O((G) => [
      ...G.slice(0, H),
      k.target.value,
      ...G.slice(H + 1)
    ]);
  }, Q = (k, H) => {
    m.current = H, k.target.select();
  };
  Me(() => {
    var k, H;
    (i == null ? void 0 : i.length) === me && (O(i.split("")), m.current = me - 1, (H = (k = E[me - 1]) == null ? void 0 : k.current) == null || H.focus());
  }, [i]), Me(() => {
    v.length === me && v.every((k) => k !== "") && t(v.join("")), e && v.some((k) => k === "") && (t(""), u == null || u({ code: "", source: null, shouldJoinClass: !1 })), d && d();
  }, [
    E,
    v,
    e,
    d,
    u,
    t
  ]);
  const ee = (k) => {
    var C, S, M, p;
    if (k.key === "Meta") return;
    if (A(null), k.key === "Backspace" || k.key === "ArrowLeft") {
      if (m.current === 0) {
        k.key === "ArrowLeft" && ((C = E[0].current) != null && C.value) && E[0].current.select();
        return;
      }
      const j = m.current - 1, oe = (S = E[j]) == null ? void 0 : S.current;
      oe && (oe.focus(), oe.select()), m.current = j;
      return;
    }
    if (k.key === "ArrowRight" && v.slice(
      m.current + 1,
      v.length
    ).every((y) => y === ""))
      return;
    const H = (M = E[m.current].current) == null ? void 0 : M.value;
    if (m.current === me - 1 || !H && k.key !== "ArrowRight")
      return;
    const G = m.current + 1, z = (p = E[G]) == null ? void 0 : p.current;
    z && (z.focus(), z.select()), m.current = G;
  };
  Me(() => (window.addEventListener("keyup", ee), () => {
    window.removeEventListener("keyup", ee);
  })), Me(() => {
    var k, H, G;
    if ((i == null ? void 0 : i.length) === me) {
      (H = (k = E[me - 1]) == null ? void 0 : k.current) == null || H.focus();
      return;
    }
    (G = E[0]) != null && G.current && E[0].current.focus();
  }, []);
  const ae = () => {
    A(null);
  }, le = (k, H) => {
    A(H);
  };
  return Me(() => ((n === !1 || c) && (async () => {
    if (R.current) {
      const G = R.current.getAnimations({
        subtree: !0
      }).map((z) => z.finished);
      await Promise.all(G), P.current = setTimeout(() => {
        var z;
        O(nr), m.current = 0, (z = E[m.current].current) == null || z.focus();
      }, Zl);
    }
  })(), () => {
    clearTimeout(P.current);
  }), [n, c, E]), /* @__PURE__ */ W.jsxs(
    "div",
    {
      className: ie(
        Le["join-code-input-wrapper"],
        "join-code-input-wrapper"
      ),
      "data-testid": "join-code-input-wrapper",
      ref: R,
      children: [
        E.map((k, H) => /* @__PURE__ */ W.jsx(
          "input",
          {
            className: ie(
              Le["join-code-input"],
              e && n !== null && Le[n ? "valid" : "invalid"],
              b === H && Le.hover,
              "join-code-input"
            ),
            value: v[H],
            onPaste: (G) => N(G),
            onChange: (G) => w(G, H),
            onClick: (G) => Q(G, H),
            onMouseEnter: (G) => le(G, H),
            onMouseLeave: ae,
            maxLength: 1,
            ref: k,
            "data-testid": "join-code-input"
          },
          H
        )),
        e && /* @__PURE__ */ W.jsx(
          Kl,
          {
            codeType: r,
            isCodeValid: n,
            isAuthed: o,
            isOnJoin: s,
            isJoiningClass: a,
            isCodeExpired: c,
            userNotAllowed: f
          }
        )
      ]
    }
  );
}, ec = "_validated_18l6r_78", Oe = {
  "free-to-paid-join": "_free-to-paid-join_18l6r_1",
  "join-with-code-title": "_join-with-code-title_18l6r_34",
  "join-welcome-title": "_join-welcome-title_18l6r_37",
  "join-auth-controls": "_join-auth-controls_18l6r_48",
  "join-auth-controls-btn": "_join-auth-controls-btn_18l6r_54",
  "join-auth-controls-signup-prompt": "_join-auth-controls-signup-prompt_18l6r_59",
  "join-auth-controls-signup": "_join-auth-controls-signup_18l6r_59",
  "join-auth-controls-logout": "_join-auth-controls-logout_18l6r_72",
  validated: ec
}, tc = ({
  isCodeValid: e,
  codeType: t,
  keycloakClient: n,
  isJoiningClass: r,
  setIsJoiningClass: o,
  redirectUri: s,
  userNotAllowed: a
}) => {
  const i = e === !0 && r || e === !1, { profile: d } = n;
  if (d)
    return /* @__PURE__ */ W.jsxs(
      "div",
      {
        className: ie(
          Oe["join-auth-controls"],
          "join-auth-controls"
        ),
        "data-testid": "join-auth-controls",
        children: [
          e && t === Ie.amplifyEnrollment && !r && !a && /* @__PURE__ */ W.jsx(
            Qe,
            {
              className: ie(
                Oe["join-auth-controls-btn"],
                "join-auth-controls-btn"
              ),
              oval: !0,
              onClick: () => o(!0),
              children: "Join class"
            }
          ),
          /* @__PURE__ */ W.jsxs(
            "div",
            {
              className: ie(
                Oe["join-auth-controls-logout"],
                i && Oe.validated,
                "join-auth-controls-logout"
              ),
              children: [
                /* @__PURE__ */ W.jsxs("p", { children: [
                  "Not ",
                  d.firstName,
                  " ",
                  d.lastName,
                  "?"
                ] }),
                /* @__PURE__ */ W.jsx(
                  "a",
                  {
                    href: n.createLogoutUrl({
                      redirectUri: s
                    }),
                    children: "Log out"
                  }
                )
              ]
            }
          )
        ]
      }
    );
  if (!d && e && t === Ie.amplifyEnrollment)
    return /* @__PURE__ */ W.jsxs(
      "div",
      {
        className: ie(
          Oe["join-auth-controls"],
          "join-auth-controls"
        ),
        "data-testid": "join-auth-controls",
        children: [
          /* @__PURE__ */ W.jsx(
            Qe,
            {
              className: ie(
                Oe["join-auth-controls-btn"],
                "join-auth-controls-btn"
              ),
              oval: !0,
              onClick: () => {
                window.top.location.href = n.createLoginUrl({
                  redirectUri: s
                });
              },
              children: "Log in"
            }
          ),
          /* @__PURE__ */ W.jsx("p", { className: ie(Oe["join-auth-controls-signup-prompt"]), children: "Don't have a username?" }),
          /* @__PURE__ */ W.jsx(
            "a",
            {
              href: n.createRegisterUrl({
                redirectUri: s
              }),
              className: ie(
                Oe["join-auth-controls-signup"],
                "join-auth-controls-signup"
              ),
              children: "Sign up here"
            }
          )
        ]
      }
    );
};
function Lr(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: nc } = Object.prototype, { getPrototypeOf: gn } = Object, Pt = /* @__PURE__ */ ((e) => (t) => {
  const n = nc.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Ae = (e) => (e = e.toLowerCase(), (t) => Pt(t) === e), jt = (e) => (t) => typeof t === e, { isArray: rt } = Array, ht = jt("undefined");
function rc(e) {
  return e !== null && !ht(e) && e.constructor !== null && !ht(e.constructor) && ge(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const kr = Ae("ArrayBuffer");
function oc(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && kr(e.buffer), t;
}
const sc = jt("string"), ge = jt("function"), $r = jt("number"), Nt = (e) => e !== null && typeof e == "object", ac = (e) => e === !0 || e === !1, _t = (e) => {
  if (Pt(e) !== "object")
    return !1;
  const t = gn(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, ic = Ae("Date"), lc = Ae("File"), cc = Ae("Blob"), uc = Ae("FileList"), fc = (e) => Nt(e) && ge(e.pipe), dc = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || ge(e.append) && ((t = Pt(e)) === "formdata" || // detect form-data instance
  t === "object" && ge(e.toString) && e.toString() === "[object FormData]"));
}, pc = Ae("URLSearchParams"), [hc, mc, yc, vc] = ["ReadableStream", "Request", "Response", "Headers"].map(Ae), bc = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function yt(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, o;
  if (typeof e != "object" && (e = [e]), rt(e))
    for (r = 0, o = e.length; r < o; r++)
      t.call(null, e[r], r, e);
  else {
    const s = n ? Object.getOwnPropertyNames(e) : Object.keys(e), a = s.length;
    let i;
    for (r = 0; r < a; r++)
      i = s[r], t.call(null, e[i], i, e);
  }
}
function Fr(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, o;
  for (; r-- > 0; )
    if (o = n[r], t === o.toLowerCase())
      return o;
  return null;
}
const Ue = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Ir = (e) => !ht(e) && e !== Ue;
function an() {
  const { caseless: e } = Ir(this) && this || {}, t = {}, n = (r, o) => {
    const s = e && Fr(t, o) || o;
    _t(t[s]) && _t(r) ? t[s] = an(t[s], r) : _t(r) ? t[s] = an({}, r) : rt(r) ? t[s] = r.slice() : t[s] = r;
  };
  for (let r = 0, o = arguments.length; r < o; r++)
    arguments[r] && yt(arguments[r], n);
  return t;
}
const gc = (e, t, n, { allOwnKeys: r } = {}) => (yt(t, (o, s) => {
  n && ge(o) ? e[s] = Lr(o, n) : e[s] = o;
}, { allOwnKeys: r }), e), Ec = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), wc = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, _c = (e, t, n, r) => {
  let o, s, a;
  const i = {};
  if (t = t || {}, e == null) return t;
  do {
    for (o = Object.getOwnPropertyNames(e), s = o.length; s-- > 0; )
      a = o[s], (!r || r(a, e, t)) && !i[a] && (t[a] = e[a], i[a] = !0);
    e = n !== !1 && gn(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, Oc = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, Rc = (e) => {
  if (!e) return null;
  if (rt(e)) return e;
  let t = e.length;
  if (!$r(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, Sc = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && gn(Uint8Array)), Tc = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let o;
  for (; (o = r.next()) && !o.done; ) {
    const s = o.value;
    t.call(e, s[0], s[1]);
  }
}, xc = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, Cc = Ae("HTMLFormElement"), Ac = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, o) {
    return r.toUpperCase() + o;
  }
), rr = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), Pc = Ae("RegExp"), Ur = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  yt(n, (o, s) => {
    let a;
    (a = t(o, s, e)) !== !1 && (r[s] = a || o);
  }), Object.defineProperties(e, r);
}, jc = (e) => {
  Ur(e, (t, n) => {
    if (ge(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (ge(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, Nc = (e, t) => {
  const n = {}, r = (o) => {
    o.forEach((s) => {
      n[s] = !0;
    });
  };
  return rt(e) ? r(e) : r(String(e).split(t)), n;
}, Mc = () => {
}, Dc = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, zt = "abcdefghijklmnopqrstuvwxyz", or = "0123456789", Br = {
  DIGIT: or,
  ALPHA: zt,
  ALPHA_DIGIT: zt + zt.toUpperCase() + or
}, Lc = (e = 16, t = Br.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function kc(e) {
  return !!(e && ge(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const $c = (e) => {
  const t = new Array(10), n = (r, o) => {
    if (Nt(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[o] = r;
        const s = rt(r) ? [] : {};
        return yt(r, (a, i) => {
          const d = n(a, o + 1);
          !ht(d) && (s[i] = d);
        }), t[o] = void 0, s;
      }
    }
    return r;
  };
  return n(e, 0);
}, Fc = Ae("AsyncFunction"), Ic = (e) => e && (Nt(e) || ge(e)) && ge(e.then) && ge(e.catch), qr = ((e, t) => e ? setImmediate : t ? ((n, r) => (Ue.addEventListener("message", ({ source: o, data: s }) => {
  o === Ue && s === n && r.length && r.shift()();
}, !1), (o) => {
  r.push(o), Ue.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  ge(Ue.postMessage)
), Uc = typeof queueMicrotask < "u" ? queueMicrotask.bind(Ue) : typeof process < "u" && process.nextTick || qr, h = {
  isArray: rt,
  isArrayBuffer: kr,
  isBuffer: rc,
  isFormData: dc,
  isArrayBufferView: oc,
  isString: sc,
  isNumber: $r,
  isBoolean: ac,
  isObject: Nt,
  isPlainObject: _t,
  isReadableStream: hc,
  isRequest: mc,
  isResponse: yc,
  isHeaders: vc,
  isUndefined: ht,
  isDate: ic,
  isFile: lc,
  isBlob: cc,
  isRegExp: Pc,
  isFunction: ge,
  isStream: fc,
  isURLSearchParams: pc,
  isTypedArray: Sc,
  isFileList: uc,
  forEach: yt,
  merge: an,
  extend: gc,
  trim: bc,
  stripBOM: Ec,
  inherits: wc,
  toFlatObject: _c,
  kindOf: Pt,
  kindOfTest: Ae,
  endsWith: Oc,
  toArray: Rc,
  forEachEntry: Tc,
  matchAll: xc,
  isHTMLForm: Cc,
  hasOwnProperty: rr,
  hasOwnProp: rr,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Ur,
  freezeMethods: jc,
  toObjectSet: Nc,
  toCamelCase: Ac,
  noop: Mc,
  toFiniteNumber: Dc,
  findKey: Fr,
  global: Ue,
  isContextDefined: Ir,
  ALPHABET: Br,
  generateString: Lc,
  isSpecCompliantForm: kc,
  toJSONObject: $c,
  isAsyncFn: Fc,
  isThenable: Ic,
  setImmediate: qr,
  asap: Uc
};
function q(e, t, n, r, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), o && (this.response = o);
}
h.inherits(q, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: h.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const Wr = q.prototype, Hr = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Hr[e] = { value: e };
});
Object.defineProperties(q, Hr);
Object.defineProperty(Wr, "isAxiosError", { value: !0 });
q.from = (e, t, n, r, o, s) => {
  const a = Object.create(Wr);
  return h.toFlatObject(e, a, function(d) {
    return d !== Error.prototype;
  }, (i) => i !== "isAxiosError"), q.call(a, e.message, t, n, r, o), a.cause = e, a.name = e.name, s && Object.assign(a, s), a;
};
const Bc = null;
function ln(e) {
  return h.isPlainObject(e) || h.isArray(e);
}
function Gr(e) {
  return h.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function sr(e, t, n) {
  return e ? e.concat(t).map(function(o, s) {
    return o = Gr(o), !n && s ? "[" + o + "]" : o;
  }).join(n ? "." : "") : t;
}
function qc(e) {
  return h.isArray(e) && !e.some(ln);
}
const Wc = h.toFlatObject(h, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function Mt(e, t, n) {
  if (!h.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = h.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(E, b) {
    return !h.isUndefined(b[E]);
  });
  const r = n.metaTokens, o = n.visitor || u, s = n.dots, a = n.indexes, d = (n.Blob || typeof Blob < "u" && Blob) && h.isSpecCompliantForm(t);
  if (!h.isFunction(o))
    throw new TypeError("visitor must be a function");
  function c(m) {
    if (m === null) return "";
    if (h.isDate(m))
      return m.toISOString();
    if (!d && h.isBlob(m))
      throw new q("Blob is not supported. Use a Buffer instead.");
    return h.isArrayBuffer(m) || h.isTypedArray(m) ? d && typeof Blob == "function" ? new Blob([m]) : Buffer.from(m) : m;
  }
  function u(m, E, b) {
    let A = m;
    if (m && !b && typeof m == "object") {
      if (h.endsWith(E, "{}"))
        E = r ? E : E.slice(0, -2), m = JSON.stringify(m);
      else if (h.isArray(m) && qc(m) || (h.isFileList(m) || h.endsWith(E, "[]")) && (A = h.toArray(m)))
        return E = Gr(E), A.forEach(function(R, N) {
          !(h.isUndefined(R) || R === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            a === !0 ? sr([E], N, s) : a === null ? E : E + "[]",
            c(R)
          );
        }), !1;
    }
    return ln(m) ? !0 : (t.append(sr(b, E, s), c(m)), !1);
  }
  const f = [], v = Object.assign(Wc, {
    defaultVisitor: u,
    convertValue: c,
    isVisitable: ln
  });
  function O(m, E) {
    if (!h.isUndefined(m)) {
      if (f.indexOf(m) !== -1)
        throw Error("Circular reference detected in " + E.join("."));
      f.push(m), h.forEach(m, function(A, P) {
        (!(h.isUndefined(A) || A === null) && o.call(
          t,
          A,
          h.isString(P) ? P.trim() : P,
          E,
          v
        )) === !0 && O(A, E ? E.concat(P) : [P]);
      }), f.pop();
    }
  }
  if (!h.isObject(e))
    throw new TypeError("data must be an object");
  return O(e), t;
}
function ar(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function En(e, t) {
  this._pairs = [], e && Mt(e, this, t);
}
const Vr = En.prototype;
Vr.append = function(t, n) {
  this._pairs.push([t, n]);
};
Vr.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, ar);
  } : ar;
  return this._pairs.map(function(o) {
    return n(o[0]) + "=" + n(o[1]);
  }, "").join("&");
};
function Hc(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Yr(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || Hc, o = n && n.serialize;
  let s;
  if (o ? s = o(t, n) : s = h.isURLSearchParams(t) ? t.toString() : new En(t, n).toString(r), s) {
    const a = e.indexOf("#");
    a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class ir {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    h.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const zr = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Gc = typeof URLSearchParams < "u" ? URLSearchParams : En, Vc = typeof FormData < "u" ? FormData : null, Yc = typeof Blob < "u" ? Blob : null, zc = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Gc,
    FormData: Vc,
    Blob: Yc
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, wn = typeof window < "u" && typeof document < "u", Jc = ((e) => wn && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator < "u" && navigator.product), Kc = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Xc = wn && window.location.href || "http://localhost", Zc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: wn,
  hasStandardBrowserEnv: Jc,
  hasStandardBrowserWebWorkerEnv: Kc,
  origin: Xc
}, Symbol.toStringTag, { value: "Module" })), Te = {
  ...Zc,
  ...zc
};
function Qc(e, t) {
  return Mt(e, new Te.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, o, s) {
      return Te.isNode && h.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : s.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function eu(e) {
  return h.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function tu(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const o = n.length;
  let s;
  for (r = 0; r < o; r++)
    s = n[r], t[s] = e[s];
  return t;
}
function Jr(e) {
  function t(n, r, o, s) {
    let a = n[s++];
    if (a === "__proto__") return !0;
    const i = Number.isFinite(+a), d = s >= n.length;
    return a = !a && h.isArray(o) ? o.length : a, d ? (h.hasOwnProp(o, a) ? o[a] = [o[a], r] : o[a] = r, !i) : ((!o[a] || !h.isObject(o[a])) && (o[a] = []), t(n, r, o[a], s) && h.isArray(o[a]) && (o[a] = tu(o[a])), !i);
  }
  if (h.isFormData(e) && h.isFunction(e.entries)) {
    const n = {};
    return h.forEachEntry(e, (r, o) => {
      t(eu(r), o, n, 0);
    }), n;
  }
  return null;
}
function nu(e, t, n) {
  if (h.isString(e))
    try {
      return (t || JSON.parse)(e), h.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const vt = {
  transitional: zr,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", o = r.indexOf("application/json") > -1, s = h.isObject(t);
    if (s && h.isHTMLForm(t) && (t = new FormData(t)), h.isFormData(t))
      return o ? JSON.stringify(Jr(t)) : t;
    if (h.isArrayBuffer(t) || h.isBuffer(t) || h.isStream(t) || h.isFile(t) || h.isBlob(t) || h.isReadableStream(t))
      return t;
    if (h.isArrayBufferView(t))
      return t.buffer;
    if (h.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let i;
    if (s) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return Qc(t, this.formSerializer).toString();
      if ((i = h.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const d = this.env && this.env.FormData;
        return Mt(
          i ? { "files[]": t } : t,
          d && new d(),
          this.formSerializer
        );
      }
    }
    return s || o ? (n.setContentType("application/json", !1), nu(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || vt.transitional, r = n && n.forcedJSONParsing, o = this.responseType === "json";
    if (h.isResponse(t) || h.isReadableStream(t))
      return t;
    if (t && h.isString(t) && (r && !this.responseType || o)) {
      const a = !(n && n.silentJSONParsing) && o;
      try {
        return JSON.parse(t);
      } catch (i) {
        if (a)
          throw i.name === "SyntaxError" ? q.from(i, q.ERR_BAD_RESPONSE, this, null, this.response) : i;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Te.classes.FormData,
    Blob: Te.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
h.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  vt.headers[e] = {};
});
const ru = h.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), ou = (e) => {
  const t = {};
  let n, r, o;
  return e && e.split(`
`).forEach(function(a) {
    o = a.indexOf(":"), n = a.substring(0, o).trim().toLowerCase(), r = a.substring(o + 1).trim(), !(!n || t[n] && ru[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, lr = Symbol("internals");
function ft(e) {
  return e && String(e).trim().toLowerCase();
}
function Ot(e) {
  return e === !1 || e == null ? e : h.isArray(e) ? e.map(Ot) : String(e);
}
function su(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const au = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Jt(e, t, n, r, o) {
  if (h.isFunction(r))
    return r.call(this, t, n);
  if (o && (t = n), !!h.isString(t)) {
    if (h.isString(r))
      return t.indexOf(r) !== -1;
    if (h.isRegExp(r))
      return r.test(t);
  }
}
function iu(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function lu(e, t) {
  const n = h.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(o, s, a) {
        return this[r].call(this, t, o, s, a);
      },
      configurable: !0
    });
  });
}
class ve {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const o = this;
    function s(i, d, c) {
      const u = ft(d);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const f = h.findKey(o, u);
      (!f || o[f] === void 0 || c === !0 || c === void 0 && o[f] !== !1) && (o[f || d] = Ot(i));
    }
    const a = (i, d) => h.forEach(i, (c, u) => s(c, u, d));
    if (h.isPlainObject(t) || t instanceof this.constructor)
      a(t, n);
    else if (h.isString(t) && (t = t.trim()) && !au(t))
      a(ou(t), n);
    else if (h.isHeaders(t))
      for (const [i, d] of t.entries())
        s(d, i, r);
    else
      t != null && s(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = ft(t), t) {
      const r = h.findKey(this, t);
      if (r) {
        const o = this[r];
        if (!n)
          return o;
        if (n === !0)
          return su(o);
        if (h.isFunction(n))
          return n.call(this, o, r);
        if (h.isRegExp(n))
          return n.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = ft(t), t) {
      const r = h.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || Jt(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let o = !1;
    function s(a) {
      if (a = ft(a), a) {
        const i = h.findKey(r, a);
        i && (!n || Jt(r, r[i], i, n)) && (delete r[i], o = !0);
      }
    }
    return h.isArray(t) ? t.forEach(s) : s(t), o;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, o = !1;
    for (; r--; ) {
      const s = n[r];
      (!t || Jt(this, this[s], s, t, !0)) && (delete this[s], o = !0);
    }
    return o;
  }
  normalize(t) {
    const n = this, r = {};
    return h.forEach(this, (o, s) => {
      const a = h.findKey(r, s);
      if (a) {
        n[a] = Ot(o), delete n[s];
        return;
      }
      const i = t ? iu(s) : String(s).trim();
      i !== s && delete n[s], n[i] = Ot(o), r[i] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return h.forEach(this, (r, o) => {
      r != null && r !== !1 && (n[o] = t && h.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((o) => r.set(o)), r;
  }
  static accessor(t) {
    const r = (this[lr] = this[lr] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function s(a) {
      const i = ft(a);
      r[i] || (lu(o, a), r[i] = !0);
    }
    return h.isArray(t) ? t.forEach(s) : s(t), this;
  }
}
ve.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
h.reduceDescriptors(ve.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
h.freezeMethods(ve);
function Kt(e, t) {
  const n = this || vt, r = t || n, o = ve.from(r.headers);
  let s = r.data;
  return h.forEach(e, function(i) {
    s = i.call(n, s, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), s;
}
function Kr(e) {
  return !!(e && e.__CANCEL__);
}
function ot(e, t, n) {
  q.call(this, e ?? "canceled", q.ERR_CANCELED, t, n), this.name = "CanceledError";
}
h.inherits(ot, q, {
  __CANCEL__: !0
});
function Xr(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new q(
    "Request failed with status code " + n.status,
    [q.ERR_BAD_REQUEST, q.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function cu(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function uu(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let o = 0, s = 0, a;
  return t = t !== void 0 ? t : 1e3, function(d) {
    const c = Date.now(), u = r[s];
    a || (a = c), n[o] = d, r[o] = c;
    let f = s, v = 0;
    for (; f !== o; )
      v += n[f++], f = f % e;
    if (o = (o + 1) % e, o === s && (s = (s + 1) % e), c - a < t)
      return;
    const O = u && c - u;
    return O ? Math.round(v * 1e3 / O) : void 0;
  };
}
function fu(e, t) {
  let n = 0, r = 1e3 / t, o, s;
  const a = (c, u = Date.now()) => {
    n = u, o = null, s && (clearTimeout(s), s = null), e.apply(null, c);
  };
  return [(...c) => {
    const u = Date.now(), f = u - n;
    f >= r ? a(c, u) : (o = c, s || (s = setTimeout(() => {
      s = null, a(o);
    }, r - f)));
  }, () => o && a(o)];
}
const xt = (e, t, n = 3) => {
  let r = 0;
  const o = uu(50, 250);
  return fu((s) => {
    const a = s.loaded, i = s.lengthComputable ? s.total : void 0, d = a - r, c = o(d), u = a <= i;
    r = a;
    const f = {
      loaded: a,
      total: i,
      progress: i ? a / i : void 0,
      bytes: d,
      rate: c || void 0,
      estimated: c && i && u ? (i - a) / c : void 0,
      event: s,
      lengthComputable: i != null,
      [t ? "download" : "upload"]: !0
    };
    e(f);
  }, n);
}, cr = (e, t) => {
  const n = e != null;
  return [(r) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: r
  }), t[1]];
}, ur = (e) => (...t) => h.asap(() => e(...t)), du = Te.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a");
    let r;
    function o(s) {
      let a = s;
      return t && (n.setAttribute("href", a), a = n.href), n.setAttribute("href", a), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return r = o(window.location.href), function(a) {
      const i = h.isString(a) ? o(a) : a;
      return i.protocol === r.protocol && i.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), pu = Te.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, o, s) {
      const a = [e + "=" + encodeURIComponent(t)];
      h.isNumber(n) && a.push("expires=" + new Date(n).toGMTString()), h.isString(r) && a.push("path=" + r), h.isString(o) && a.push("domain=" + o), s === !0 && a.push("secure"), document.cookie = a.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function hu(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function mu(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Zr(e, t) {
  return e && !hu(t) ? mu(e, t) : t;
}
const fr = (e) => e instanceof ve ? { ...e } : e;
function ze(e, t) {
  t = t || {};
  const n = {};
  function r(c, u, f) {
    return h.isPlainObject(c) && h.isPlainObject(u) ? h.merge.call({ caseless: f }, c, u) : h.isPlainObject(u) ? h.merge({}, u) : h.isArray(u) ? u.slice() : u;
  }
  function o(c, u, f) {
    if (h.isUndefined(u)) {
      if (!h.isUndefined(c))
        return r(void 0, c, f);
    } else return r(c, u, f);
  }
  function s(c, u) {
    if (!h.isUndefined(u))
      return r(void 0, u);
  }
  function a(c, u) {
    if (h.isUndefined(u)) {
      if (!h.isUndefined(c))
        return r(void 0, c);
    } else return r(void 0, u);
  }
  function i(c, u, f) {
    if (f in t)
      return r(c, u);
    if (f in e)
      return r(void 0, c);
  }
  const d = {
    url: s,
    method: s,
    data: s,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    withXSRFToken: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    beforeRedirect: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    responseEncoding: a,
    validateStatus: i,
    headers: (c, u) => o(fr(c), fr(u), !0)
  };
  return h.forEach(Object.keys(Object.assign({}, e, t)), function(u) {
    const f = d[u] || o, v = f(e[u], t[u], u);
    h.isUndefined(v) && f !== i || (n[u] = v);
  }), n;
}
const Qr = (e) => {
  const t = ze({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: o, xsrfCookieName: s, headers: a, auth: i } = t;
  t.headers = a = ve.from(a), t.url = Yr(Zr(t.baseURL, t.url), e.params, e.paramsSerializer), i && a.set(
    "Authorization",
    "Basic " + btoa((i.username || "") + ":" + (i.password ? unescape(encodeURIComponent(i.password)) : ""))
  );
  let d;
  if (h.isFormData(n)) {
    if (Te.hasStandardBrowserEnv || Te.hasStandardBrowserWebWorkerEnv)
      a.setContentType(void 0);
    else if ((d = a.getContentType()) !== !1) {
      const [c, ...u] = d ? d.split(";").map((f) => f.trim()).filter(Boolean) : [];
      a.setContentType([c || "multipart/form-data", ...u].join("; "));
    }
  }
  if (Te.hasStandardBrowserEnv && (r && h.isFunction(r) && (r = r(t)), r || r !== !1 && du(t.url))) {
    const c = o && s && pu.read(s);
    c && a.set(o, c);
  }
  return t;
}, yu = typeof XMLHttpRequest < "u", vu = yu && function(e) {
  return new Promise(function(n, r) {
    const o = Qr(e);
    let s = o.data;
    const a = ve.from(o.headers).normalize();
    let { responseType: i, onUploadProgress: d, onDownloadProgress: c } = o, u, f, v, O, m;
    function E() {
      O && O(), m && m(), o.cancelToken && o.cancelToken.unsubscribe(u), o.signal && o.signal.removeEventListener("abort", u);
    }
    let b = new XMLHttpRequest();
    b.open(o.method.toUpperCase(), o.url, !0), b.timeout = o.timeout;
    function A() {
      if (!b)
        return;
      const R = ve.from(
        "getAllResponseHeaders" in b && b.getAllResponseHeaders()
      ), w = {
        data: !i || i === "text" || i === "json" ? b.responseText : b.response,
        status: b.status,
        statusText: b.statusText,
        headers: R,
        config: e,
        request: b
      };
      Xr(function(ee) {
        n(ee), E();
      }, function(ee) {
        r(ee), E();
      }, w), b = null;
    }
    "onloadend" in b ? b.onloadend = A : b.onreadystatechange = function() {
      !b || b.readyState !== 4 || b.status === 0 && !(b.responseURL && b.responseURL.indexOf("file:") === 0) || setTimeout(A);
    }, b.onabort = function() {
      b && (r(new q("Request aborted", q.ECONNABORTED, e, b)), b = null);
    }, b.onerror = function() {
      r(new q("Network Error", q.ERR_NETWORK, e, b)), b = null;
    }, b.ontimeout = function() {
      let N = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const w = o.transitional || zr;
      o.timeoutErrorMessage && (N = o.timeoutErrorMessage), r(new q(
        N,
        w.clarifyTimeoutError ? q.ETIMEDOUT : q.ECONNABORTED,
        e,
        b
      )), b = null;
    }, s === void 0 && a.setContentType(null), "setRequestHeader" in b && h.forEach(a.toJSON(), function(N, w) {
      b.setRequestHeader(w, N);
    }), h.isUndefined(o.withCredentials) || (b.withCredentials = !!o.withCredentials), i && i !== "json" && (b.responseType = o.responseType), c && ([v, m] = xt(c, !0), b.addEventListener("progress", v)), d && b.upload && ([f, O] = xt(d), b.upload.addEventListener("progress", f), b.upload.addEventListener("loadend", O)), (o.cancelToken || o.signal) && (u = (R) => {
      b && (r(!R || R.type ? new ot(null, e, b) : R), b.abort(), b = null);
    }, o.cancelToken && o.cancelToken.subscribe(u), o.signal && (o.signal.aborted ? u() : o.signal.addEventListener("abort", u)));
    const P = cu(o.url);
    if (P && Te.protocols.indexOf(P) === -1) {
      r(new q("Unsupported protocol " + P + ":", q.ERR_BAD_REQUEST, e));
      return;
    }
    b.send(s || null);
  });
}, bu = (e, t) => {
  let n = new AbortController(), r;
  const o = function(d) {
    if (!r) {
      r = !0, a();
      const c = d instanceof Error ? d : this.reason;
      n.abort(c instanceof q ? c : new ot(c instanceof Error ? c.message : c));
    }
  };
  let s = t && setTimeout(() => {
    o(new q(`timeout ${t} of ms exceeded`, q.ETIMEDOUT));
  }, t);
  const a = () => {
    e && (s && clearTimeout(s), s = null, e.forEach((d) => {
      d && (d.removeEventListener ? d.removeEventListener("abort", o) : d.unsubscribe(o));
    }), e = null);
  };
  e.forEach((d) => d && d.addEventListener && d.addEventListener("abort", o));
  const { signal: i } = n;
  return i.unsubscribe = a, [i, () => {
    s && clearTimeout(s), s = null;
  }];
}, gu = function* (e, t) {
  let n = e.byteLength;
  if (!t || n < t) {
    yield e;
    return;
  }
  let r = 0, o;
  for (; r < n; )
    o = r + t, yield e.slice(r, o), r = o;
}, Eu = async function* (e, t, n) {
  for await (const r of e)
    yield* gu(ArrayBuffer.isView(r) ? r : await n(String(r)), t);
}, dr = (e, t, n, r, o) => {
  const s = Eu(e, t, o);
  let a = 0, i, d = (c) => {
    i || (i = !0, r && r(c));
  };
  return new ReadableStream({
    async pull(c) {
      try {
        const { done: u, value: f } = await s.next();
        if (u) {
          d(), c.close();
          return;
        }
        let v = f.byteLength;
        if (n) {
          let O = a += v;
          n(O);
        }
        c.enqueue(new Uint8Array(f));
      } catch (u) {
        throw d(u), u;
      }
    },
    cancel(c) {
      return d(c), s.return();
    }
  }, {
    highWaterMark: 2
  });
}, Dt = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", eo = Dt && typeof ReadableStream == "function", cn = Dt && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), to = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, wu = eo && to(() => {
  let e = !1;
  const t = new Request(Te.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), pr = 64 * 1024, un = eo && to(() => h.isReadableStream(new Response("").body)), Ct = {
  stream: un && ((e) => e.body)
};
Dt && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !Ct[t] && (Ct[t] = h.isFunction(e[t]) ? (n) => n[t]() : (n, r) => {
      throw new q(`Response type '${t}' is not supported`, q.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const _u = async (e) => {
  if (e == null)
    return 0;
  if (h.isBlob(e))
    return e.size;
  if (h.isSpecCompliantForm(e))
    return (await new Request(e).arrayBuffer()).byteLength;
  if (h.isArrayBufferView(e) || h.isArrayBuffer(e))
    return e.byteLength;
  if (h.isURLSearchParams(e) && (e = e + ""), h.isString(e))
    return (await cn(e)).byteLength;
}, Ou = async (e, t) => {
  const n = h.toFiniteNumber(e.getContentLength());
  return n ?? _u(t);
}, Ru = Dt && (async (e) => {
  let {
    url: t,
    method: n,
    data: r,
    signal: o,
    cancelToken: s,
    timeout: a,
    onDownloadProgress: i,
    onUploadProgress: d,
    responseType: c,
    headers: u,
    withCredentials: f = "same-origin",
    fetchOptions: v
  } = Qr(e);
  c = c ? (c + "").toLowerCase() : "text";
  let [O, m] = o || s || a ? bu([o, s], a) : [], E, b;
  const A = () => {
    !E && setTimeout(() => {
      O && O.unsubscribe();
    }), E = !0;
  };
  let P;
  try {
    if (d && wu && n !== "get" && n !== "head" && (P = await Ou(u, r)) !== 0) {
      let Q = new Request(t, {
        method: "POST",
        body: r,
        duplex: "half"
      }), ee;
      if (h.isFormData(r) && (ee = Q.headers.get("content-type")) && u.setContentType(ee), Q.body) {
        const [ae, le] = cr(
          P,
          xt(ur(d))
        );
        r = dr(Q.body, pr, ae, le, cn);
      }
    }
    h.isString(f) || (f = f ? "include" : "omit"), b = new Request(t, {
      ...v,
      signal: O,
      method: n.toUpperCase(),
      headers: u.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: f
    });
    let R = await fetch(b);
    const N = un && (c === "stream" || c === "response");
    if (un && (i || N)) {
      const Q = {};
      ["status", "statusText", "headers"].forEach((k) => {
        Q[k] = R[k];
      });
      const ee = h.toFiniteNumber(R.headers.get("content-length")), [ae, le] = i && cr(
        ee,
        xt(ur(i), !0)
      ) || [];
      R = new Response(
        dr(R.body, pr, ae, () => {
          le && le(), N && A();
        }, cn),
        Q
      );
    }
    c = c || "text";
    let w = await Ct[h.findKey(Ct, c) || "text"](R, e);
    return !N && A(), m && m(), await new Promise((Q, ee) => {
      Xr(Q, ee, {
        data: w,
        headers: ve.from(R.headers),
        status: R.status,
        statusText: R.statusText,
        config: e,
        request: b
      });
    });
  } catch (R) {
    throw A(), R && R.name === "TypeError" && /fetch/i.test(R.message) ? Object.assign(
      new q("Network Error", q.ERR_NETWORK, e, b),
      {
        cause: R.cause || R
      }
    ) : q.from(R, R && R.code, e, b);
  }
}), fn = {
  http: Bc,
  xhr: vu,
  fetch: Ru
};
h.forEach(fn, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const hr = (e) => `- ${e}`, Su = (e) => h.isFunction(e) || e === null || e === !1, no = {
  getAdapter: (e) => {
    e = h.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const o = {};
    for (let s = 0; s < t; s++) {
      n = e[s];
      let a;
      if (r = n, !Su(n) && (r = fn[(a = String(n)).toLowerCase()], r === void 0))
        throw new q(`Unknown adapter '${a}'`);
      if (r)
        break;
      o[a || "#" + s] = r;
    }
    if (!r) {
      const s = Object.entries(o).map(
        ([i, d]) => `adapter ${i} ` + (d === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let a = t ? s.length > 1 ? `since :
` + s.map(hr).join(`
`) : " " + hr(s[0]) : "as no adapter specified";
      throw new q(
        "There is no suitable adapter to dispatch the request " + a,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: fn
};
function Xt(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new ot(null, e);
}
function mr(e) {
  return Xt(e), e.headers = ve.from(e.headers), e.data = Kt.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), no.getAdapter(e.adapter || vt.adapter)(e).then(function(r) {
    return Xt(e), r.data = Kt.call(
      e,
      e.transformResponse,
      r
    ), r.headers = ve.from(r.headers), r;
  }, function(r) {
    return Kr(r) || (Xt(e), r && r.response && (r.response.data = Kt.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = ve.from(r.response.headers))), Promise.reject(r);
  });
}
const ro = "1.7.4", _n = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  _n[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const yr = {};
_n.transitional = function(t, n, r) {
  function o(s, a) {
    return "[Axios v" + ro + "] Transitional option '" + s + "'" + a + (r ? ". " + r : "");
  }
  return (s, a, i) => {
    if (t === !1)
      throw new q(
        o(a, " has been removed" + (n ? " in " + n : "")),
        q.ERR_DEPRECATED
      );
    return n && !yr[a] && (yr[a] = !0, console.warn(
      o(
        a,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(s, a, i) : !0;
  };
};
function Tu(e, t, n) {
  if (typeof e != "object")
    throw new q("options must be an object", q.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let o = r.length;
  for (; o-- > 0; ) {
    const s = r[o], a = t[s];
    if (a) {
      const i = e[s], d = i === void 0 || a(i, s, e);
      if (d !== !0)
        throw new q("option " + s + " must be " + d, q.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new q("Unknown option " + s, q.ERR_BAD_OPTION);
  }
}
const dn = {
  assertOptions: Tu,
  validators: _n
}, Ne = dn.validators;
class Ge {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new ir(),
      response: new ir()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let o;
        Error.captureStackTrace ? Error.captureStackTrace(o = {}) : o = new Error();
        const s = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? s && !String(r.stack).endsWith(s.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + s) : r.stack = s;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = ze(this.defaults, n);
    const { transitional: r, paramsSerializer: o, headers: s } = n;
    r !== void 0 && dn.assertOptions(r, {
      silentJSONParsing: Ne.transitional(Ne.boolean),
      forcedJSONParsing: Ne.transitional(Ne.boolean),
      clarifyTimeoutError: Ne.transitional(Ne.boolean)
    }, !1), o != null && (h.isFunction(o) ? n.paramsSerializer = {
      serialize: o
    } : dn.assertOptions(o, {
      encode: Ne.function,
      serialize: Ne.function
    }, !0)), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let a = s && h.merge(
      s.common,
      s[n.method]
    );
    s && h.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (m) => {
        delete s[m];
      }
    ), n.headers = ve.concat(a, s);
    const i = [];
    let d = !0;
    this.interceptors.request.forEach(function(E) {
      typeof E.runWhen == "function" && E.runWhen(n) === !1 || (d = d && E.synchronous, i.unshift(E.fulfilled, E.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(E) {
      c.push(E.fulfilled, E.rejected);
    });
    let u, f = 0, v;
    if (!d) {
      const m = [mr.bind(this), void 0];
      for (m.unshift.apply(m, i), m.push.apply(m, c), v = m.length, u = Promise.resolve(n); f < v; )
        u = u.then(m[f++], m[f++]);
      return u;
    }
    v = i.length;
    let O = n;
    for (f = 0; f < v; ) {
      const m = i[f++], E = i[f++];
      try {
        O = m(O);
      } catch (b) {
        E.call(this, b);
        break;
      }
    }
    try {
      u = mr.call(this, O);
    } catch (m) {
      return Promise.reject(m);
    }
    for (f = 0, v = c.length; f < v; )
      u = u.then(c[f++], c[f++]);
    return u;
  }
  getUri(t) {
    t = ze(this.defaults, t);
    const n = Zr(t.baseURL, t.url);
    return Yr(n, t.params, t.paramsSerializer);
  }
}
h.forEach(["delete", "get", "head", "options"], function(t) {
  Ge.prototype[t] = function(n, r) {
    return this.request(ze(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
h.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(s, a, i) {
      return this.request(ze(i || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: s,
        data: a
      }));
    };
  }
  Ge.prototype[t] = n(), Ge.prototype[t + "Form"] = n(!0);
});
class On {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(s) {
      n = s;
    });
    const r = this;
    this.promise.then((o) => {
      if (!r._listeners) return;
      let s = r._listeners.length;
      for (; s-- > 0; )
        r._listeners[s](o);
      r._listeners = null;
    }), this.promise.then = (o) => {
      let s;
      const a = new Promise((i) => {
        r.subscribe(i), s = i;
      }).then(o);
      return a.cancel = function() {
        r.unsubscribe(s);
      }, a;
    }, t(function(s, a, i) {
      r.reason || (r.reason = new ot(s, a, i), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new On(function(o) {
        t = o;
      }),
      cancel: t
    };
  }
}
function xu(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function Cu(e) {
  return h.isObject(e) && e.isAxiosError === !0;
}
const pn = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(pn).forEach(([e, t]) => {
  pn[t] = e;
});
function oo(e) {
  const t = new Ge(e), n = Lr(Ge.prototype.request, t);
  return h.extend(n, Ge.prototype, t, { allOwnKeys: !0 }), h.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(o) {
    return oo(ze(e, o));
  }, n;
}
const ue = oo(vt);
ue.Axios = Ge;
ue.CanceledError = ot;
ue.CancelToken = On;
ue.isCancel = Kr;
ue.VERSION = ro;
ue.toFormData = Mt;
ue.AxiosError = q;
ue.Cancel = ue.CanceledError;
ue.all = function(t) {
  return Promise.all(t);
};
ue.spread = xu;
ue.isAxiosError = Cu;
ue.mergeConfig = ze;
ue.AxiosHeaders = ve;
ue.formToJSON = (e) => Jr(h.isHTMLForm(e) ? new FormData(e) : e);
ue.getAdapter = no.getAdapter;
ue.HttpStatusCode = pn;
ue.default = ue;
const Au = () => {
  const e = window.location.hostname;
  return e.includes("local") || e.includes("poc") ? "-devci.poc" : e.includes("staging") ? "-staging.stage" : "";
};
class Pu {
  constructor() {
    it(this, "ENV");
    it(this, "FTP_BFF_URL");
    it(this, "SHARED_EXP_BFF_URL");
    const t = Au();
    t === "-devci.poc" ? this.ENV = "devci" : t === "-staging.stage" ? this.ENV = "staging" : this.ENV = "prod", this.FTP_BFF_URL = `https://api${t}.learning.amplify.com/ftp-bff`, this.SHARED_EXP_BFF_URL = `https://api${t}.learning.amplify.com/shared-exp-bff`;
  }
  getEnvironment() {
    return this.ENV;
  }
  isLocalSetup() {
    return window.location.hostname.includes("local") || window.location.hostname === "127.0.0.1";
  }
}
const so = new Pu();
so.SHARED_EXP_BFF_URL;
class ju {
  constructor() {
    it(this, "baseURL");
    this.baseURL = `${so.FTP_BFF_URL}/code`;
  }
  /**
   * Get code information
   * @async
   * @function getCode
   * @param {string} code Short code
   * @returns {Promise<CodeInfo | undefined>} Promise with code information.
   */
  async getCode(t) {
    try {
      const { data: n } = await ue.get(
        `${this.baseURL}/${t}`
      );
      return n;
    } catch (n) {
      throw console.error("Failed to get the code information", n), n;
    }
  }
  /**
   * Join student to a class by short code
   * @async
   * @function joinCode
   * @param {Omit<CodeInfo, 'expirationTS'>} codeInfo Code information except expiration timestamp
   * @param {string} token Bearer token to make a request
   * @returns {Promise<JoinInfo | undefined>} Promise with information about whether joining the class was successful or not.
   */
  async joinCode(t, n) {
    const { code: r, source: o } = t;
    try {
      const { data: s } = await ue.post(
        `${this.baseURL}/${r}/${o}/join`,
        void 0,
        { headers: { Authorization: `Bearer ${n}` } }
      );
      return s;
    } catch (s) {
      throw console.error("Failed to join a class", s), s;
    }
  }
}
const vr = new ju(), ku = ({
  isOpen: e = !1,
  onClose: t,
  appElementId: n,
  externalClassName: r,
  isOnJoin: o,
  keycloakClient: s,
  closeButtonClassName: a = "",
  redirectUri: i,
  codeFromUrl: d,
  setCodeInfo: c
}) => {
  const { profile: u, token: f } = s, [v, O] = Pe(!1), [m, E] = Pe(""), [b, A] = Pe(null), [P, R] = Pe(null), [N, w] = Pe(null), [Q, ee] = Pe(!1), [ae, le] = Pe(!1), [k, H] = Pe(!1);
  Me(() => {
    (async () => {
      await s.loadUserProfile();
      const C = s.hasRealmRole("STUDENT");
      le(C);
    })().finally(() => O(!0));
  }, [s]), Me(() => {
    if (m) {
      let z = !1;
      return (async () => {
        try {
          R(null), A(null), w(null);
          const S = await vr.getCode(m);
          if (S && !z) {
            const M = S.expirationTS !== null && new Date(S.expirationTS).getTime() < Date.now();
            R(!M), w(M), A(S.source), c == null || c({
              code: M ? "" : m,
              source: M ? null : S.source,
              shouldJoinClass: !k && !M && S.source === Ie.singleSession
            }), H(
              !ae && !!(s != null && s.authenticated) && S.source !== Ie.singleSession
            ), !M && S.source === Ie.amplifyEnrollment && !o && ee(!0);
          }
        } catch {
          z || (R(!1), A(null), c == null || c({
            code: "",
            source: null,
            shouldJoinClass: !1
          }));
        }
      })(), () => {
        z = !0;
      };
    } else
      R(null), A(null), w(null);
  }, [m, c, k]), Me(() => {
    Q && b === Ie.amplifyEnrollment && f && (async () => {
      try {
        const C = await vr.joinCode(
          { code: m, source: b },
          f
        );
        C && C.success && (c == null || c({
          code: m,
          source: b,
          shouldJoinClass: !0
        }));
      } catch {
        R(!1);
      } finally {
        ee(!1);
      }
    })();
  }, [b, m, f, c, o, Q]);
  const G = /* @__PURE__ */ W.jsxs(W.Fragment, { children: [
    o && u ? /* @__PURE__ */ W.jsxs(
      "h1",
      {
        className: ie(
          Oe["join-welcome-title"],
          "join-welcome-title"
        ),
        children: [
          "Welcome, ",
          u.firstName,
          " ",
          u.lastName,
          "!"
        ]
      }
    ) : /* @__PURE__ */ W.jsxs(W.Fragment, { children: [
      /* @__PURE__ */ W.jsx(
        "h1",
        {
          className: ie(
            Oe["join-with-code-title"],
            "join-with-code-title"
          ),
          children: "Join with a code"
        }
      ),
      /* @__PURE__ */ W.jsx("h2", { children: "Enter the code shared by your teacher" })
    ] }),
    /* @__PURE__ */ W.jsx(
      Ql,
      {
        codeValue: m,
        codeFromUrl: d,
        setCodeValue: E,
        isValid: P,
        codeType: b,
        isAuthed: !!(s != null && s.authenticated),
        isOnJoin: o,
        isJoiningClass: Q,
        isCodeExpired: N,
        setCodeInfo: c,
        userNotAllowed: k
      }
    )
  ] });
  if (!(o && !v))
    return o ? /* @__PURE__ */ W.jsxs(
      "div",
      {
        className: ie(Oe["free-to-paid-join"], r),
        "data-testid": "free-to-paid-join-wrapper",
        children: [
          G,
          /* @__PURE__ */ W.jsx(
            tc,
            {
              isCodeValid: P,
              codeType: b,
              keycloakClient: s,
              isJoiningClass: Q,
              setIsJoiningClass: ee,
              redirectUri: i,
              userNotAllowed: k
            }
          )
        ]
      }
    ) : /* @__PURE__ */ W.jsx(
      Xa,
      {
        className: ie(Oe["free-to-paid-join"], r),
        isOpen: e,
        onClose: t,
        appElementId: n,
        contentLabel: "Join Modal",
        closeButtonClassName: a,
        children: G
      }
    );
};
export {
  ku as Join
};
